// // // // // import React from 'react'

// // // // // const AdminAppraisalForm = () => {
// // // // //   return (
// // // // //     <div>
      
// // // // //     </div>
// // // // //   )
// // // // // }

// // // // // export default AdminAppraisalForm


// // // // import React, { useEffect, useMemo, useState } from "react";
// // // // import styled from "styled-components";
// // // // import { useParams, useNavigate } from "react-router-dom";
// // // // import { FaArrowLeft, FaShieldAlt } from "react-icons/fa";
// // // // import NavBarSuper from "./NavBarSuper";
// // // // import DashboardHeader from "./DashboardHeader";
// // // // import Footer from "./Footer";
// // // // import api from "../api";
// // // // import { useTheme } from "../App";

// // // // /* ================= HELPERS ================= */
// // // // const getCurrentMonthName = () => {
// // // //   const date = new Date();
// // // //   return date.toLocaleString("default", { month: "long", year: "numeric" });
// // // // };

// // // // const generateMonthOptions = () => {
// // // //   const months = [];
// // // //   const date = new Date();
// // // //   date.setMonth(date.getMonth() - 3); 
// // // //   for (let i = 0; i < 12; i++) {
// // // //     months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
// // // //     date.setMonth(date.getMonth() + 1);
// // // //   }
// // // //   return months;
// // // // };

// // // // const parseScoreValue = (value) => {
// // // //   if (value === "N/A" || value === "" || value == null) return null;
// // // //   const num = Number(value);
// // // //   return Number.isNaN(num) ? null : num;
// // // // };
// // // // const ScoreValue = (value) => {
// // // //   if (value === "N/A" || value === "" || value == null) return null;
// // // //   const num = Number(value);
// // // //   return Number.isNaN(num) ? null : num;
// // // // };

// // // // const formatScore = (value) => Number(value || 0).toFixed(1);

// // // // const complianceItems = [
// // // //   { attribute: "Feedback", description: "Measures the progress and status of work with the use of relevant tools. Gives quality and consistent information on assigned tasks." },
// // // //   { attribute: "Responsiveness to official communication", description: "Is reachable and responsive on Kingschat and official communication platforms." },
// // // //   { attribute: "Care and Maintenance of office space and equipment", description: "Consistently maintains a clean, tidy and orderly office space. Takes good care of all equipment, keeping them in optimal working condition." },
// // // //   { attribute: "Ministry Programs", description: "Participates in Ministry Global Programs such as Your Loveworld, GDOP, etc." },
// // // //   { attribute: "Church Services and Meetings", description: "Consistently and punctually at Sunday and Wednesday Church Services, Prayer Services." },
// // // //   { attribute: "Monthly Goals", description: "Promptly submits monthly goals before 1st 12.00am of each month." },
// // // //   { attribute: "Weekly Goals", description: "Promptly submits weekly goals on or before Saturday 11.59pm." },
// // // //   { attribute: "Weekly Reporting", description: "Promptly submits all weekly reports on or before Saturday 11:59pm." },
// // // //   { attribute: "Performance Reporting", description: "Promptly submits performance appraisal form on or before 1st of each month." },
// // // //   { attribute: "Online publicity and awareness creation", description: "Consistently publicizes, promotes and creates awareness of departmental products and activities online and physically as required. (Free type)" },
// // // //   { attribute: "Staff Trainings", description: "Consistently and punctually at Staff Training Programs and products, STDL, other Ministry trainings for staff." },
// // // //   { attribute: "Office Attendance", description: "Consistently and punctually at the office." },
// // // //   { attribute: "Office Prayer Meetings", description: "Consistently and punctually at Staff Office Prayer Meetings (onsite and online)." },
// // // //   { attribute: "Staff Chapel & Care Group Meetings", description: "Consistently and punctually at Staff Chapel Services & Staff Care Group Meetings."},
// // // //   { attribute: "Uniforms", description: "Wears clean, proper and appropriate uniforms." },
// // // // ];

// // // // const ratingScale = [
// // // //   { value: "", label: "Select..." },
// // // //   { value: "N/A", label: "N/A - Not applicable" },
// // // //   { value: "0", label: "0 - Not evident" },
// // // //   { value: "1", label: "1 - Unsatisfactory" },
// // // //   { value: "2", label: "2 - Below expectation" },
// // // //   { value: "3", label: "3 - Met some expectation" },
// // // //   { value: "4", label: "4 - Met expectation" },
// // // //   { value: "5", label: "5 - Surpassed expectation" },
// // // // ];

// // // // /* ================= PAGE LAYOUT & THEME VARIABLES ================= */
// // // // const Container = styled.div`
// // // //   --sidebar-expanded: 260px;
// // // //   --sidebar-collapsed: 90px;
  
// // // //   --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
// // // //   --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.96)'};
// // // //   --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
// // // //   --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
// // // //   --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
// // // //   --input-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'};
// // // //   --table-header-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#f0fdf4'};
// // // //   --table-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#bbf7d0'};

// // // //   min-height: 100vh;
// // // //   background: var(--page-bg);
// // // //   color: var(--text-main);
// // // //   margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
// // // //   transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;

// // // //   @media (max-width: 1023px) { margin-left: 0; }
// // // // `;

// // // // const Main = styled.main`
// // // //   width: min(1450px, calc(100% - 32px)); margin: 0 auto; padding: 94px 0 80px;
// // // //   @media (max-width: 1023px) { width: min(100%, calc(100% - 24px)); padding-top: 86px; }
// // // // `;

// // // // /* ================= COMPONENTS ================= */
// // // // const BackButton = styled.button` 
// // // //   display: inline-flex; align-items: center; gap: 8px; background: none; border: none;
// // // //   color: #16a34a; font-weight: 800; font-size: 1rem; cursor: pointer; transition: transform 0.2s ease; padding: 0; margin-bottom: 24px;
// // // //   &:hover { transform: translateX(-4px); text-decoration: underline; }
// // // // `;

// // // // const SectionCard = styled.section`
// // // //   background: var(--card-bg); border: 1px solid var(--border); border-radius: 28px; padding: 32px; box-shadow: 0 12px 30px rgba(0,0,0,0.05); margin-bottom: 32px;
// // // //   transition: background 0.3s ease, border 0.3s ease;
// // // //   @media (max-width: 768px) { padding: 20px; border-radius: 22px; }
// // // // `;

// // // // const HeaderRow = styled.div`
// // // //   display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 16px; margin-bottom: 24px;
// // // // `;

// // // // const SectionTitle = styled.h2` margin: 0; font-size: clamp(1.2rem, 1rem + 0.6vw, 1.6rem); font-weight: 900; color: var(--text-main); display: flex; align-items: center; gap: 12px; `;

// // // // const GlobalMonthSelect = styled.select`
// // // //   padding: 8px 16px; border-radius: 12px; border: 2px solid ${({ $isDarkMode }) => $isDarkMode ? '#22c55e' : '#86efac'}; 
// // // //   font-size: 1.1rem; font-weight: 800; color: #16a34a; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.1)' : '#f0fdf4'}; 
// // // //   outline: none; cursor: pointer; transition: all 0.2s;
// // // //   &:focus { border-color: #16a34a; box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.1); }
// // // // `;

// // // // const Subtitle = styled.p` color: var(--text-soft); margin: 0; font-size: 0.95rem; line-height: 1.6; max-width: 800px; `;

// // // // const StaffInfoBox = styled.div`
// // // //   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.05)' : '#eff6ff'};
// // // //   border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#1e3a8a' : '#bfdbfe'};
// // // //   padding: 16px 20px; border-radius: 16px; margin-bottom: 24px; display: inline-flex; align-items: center; gap: 16px; flex-wrap: wrap;
// // // // `;

// // // // const StaffName = styled.div` font-size: 1.1rem; font-weight: 800; color: ${({ $isDarkMode }) => $isDarkMode ? '#93c5fd' : '#1e40af'}; `;
// // // // const StaffRole = styled.div` font-size: 0.9rem; font-weight: 600; color: var(--text-soft); background: var(--card-bg); padding: 4px 10px; border-radius: 999px; border: 1px solid var(--border); `;

// // // // /* ================= TABLE STYLES ================= */
// // // // const TableWrapper = styled.div`
// // // //   width: 100%; overflow-x: auto; border-radius: 14px; border: 1px solid var(--table-border);
// // // // `;

// // // // const Table = styled.table`
// // // //   width: 100%; border-collapse: separate; border-spacing: 0; background: transparent; table-layout: fixed; min-width: 1000px;
// // // // `;

// // // // const Th = styled.th`
// // // //   background: var(--table-header-bg); padding: 14px 10px; text-align: left; font-size: 12px; font-weight: 800; 
// // // //   color: ${({ $isDarkMode }) => $isDarkMode ? '#86efac' : '#15803d'}; border-bottom: 1px solid var(--table-border); vertical-align: middle;
// // // //   &:first-child { border-top-left-radius: 14px; } &:last-child { border-top-right-radius: 14px; }
// // // // `;

// // // // const Td = styled.td`
// // // //   padding: 14px 10px; border-bottom: 1px solid var(--table-border); vertical-align: top;
// // // // `;

// // // // const Serial = styled.div`
// // // //   width: 28px; height: 28px; display: grid; place-items: center; border-radius: 50%; 
// // // //   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.15)' : '#f0fdf4'}; 
// // // //   color: ${({ $isDarkMode }) => $isDarkMode ? '#86efac' : '#15803d'}; font-weight: 800; font-size: 0.85rem;
// // // // `;

// // // // const AttributeBox = styled.div`
// // // //   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.05)' : '#f0fdf4'}; 
// // // //   padding: 8px 12px; border-left: 4px solid #22c55e; border-radius: 8px; font-weight: 700; 
// // // //   color: ${({ $isDarkMode }) => $isDarkMode ? '#bbf7d0' : '#14532d'}; font-size: 0.85rem; word-wrap: break-word;
// // // // `;

// // // // const DisabledInput = styled.div`
// // // //   min-height: 32px; border: 1px solid var(--input-border); background: ${({ $isDarkMode }) => $isDarkMode ? 'var(--input-bg)' : '#f8fafc'};
// // // //   color: var(--text-soft); border-radius: 6px; padding: 8px; line-height: 1.4; white-space: pre-wrap; font-size: 13px;
// // // // `;

// // // // const SmallScore = styled.div`
// // // //   width: 36px; height: 36px; display: inline-flex; align-items: center; justify-content: center; border-radius: 6px;
// // // //   border: 1px solid var(--input-border); background: ${({ $isDarkMode }) => $isDarkMode ? 'var(--input-bg)' : '#f8fafc'}; 
// // // //   font-weight: 800; color: var(--text-soft); font-size: 13px;
// // // // `;

// // // // const Select = styled.select`
// // // //   width: 100%; padding: 10px; border-radius: 8px; border: 2px solid ${({ $isDarkMode }) => $isDarkMode ? '#14532d' : '#86efac'}; 
// // // //   font-size: 13px; font-weight: 700; color: var(--text-main); background: var(--input-bg); outline: none; transition: all 0.2s;
// // // //   &:focus { border-color: #22c55e; box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15); }
// // // // `;

// // // // const Textarea = styled.textarea`
// // // //   width: 100%; min-height: 60px; padding: 10px; border: 1px solid var(--input-border); border-radius: 8px; resize: vertical; 
// // // //   font-size: 13px; line-height: 1.4; background: var(--input-bg); color: var(--text-main); outline: none; box-sizing: border-box;
// // // //   &:focus { border-color: #22c55e; box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15); }
// // // // `;

// // // // /* ================= SCORE CALCULATION BOXES ================= */
// // // // const CalcGrid = styled.div` display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-top: 24px; @media (max-width: 900px) { grid-template-columns: 1fr; } `;

// // // // const CalcBox = styled.div`
// // // //   padding: 24px; border-radius: 20px; border-left: 5px solid; line-height: 1.75; box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
// // // //   background: ${({ variant, $isDarkMode }) => 
// // // //     variant === "admin" ? ($isDarkMode ? 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)' : "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)") :
// // // //     variant === "supervisor" ? ($isDarkMode ? 'linear-gradient(135deg, #064e3b 0%, #14532d 100%)' : "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)") :
// // // //     ($isDarkMode ? 'linear-gradient(135deg, #1e293b 0%, #334155 100%)' : "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)")
// // // //   };
// // // //   border-left-color: ${({ variant }) => variant === "admin" ? "#8b5cf6" : variant === "supervisor" ? "#16a34a" : "#64748b"};
// // // // `;

// // // // const CalcTitle = styled.div`
// // // //   font-size: 1.05rem; font-weight: 900; margin-bottom: 8px;
// // // //   color: ${({ variant, $isDarkMode }) => variant === "admin" ? ($isDarkMode ? "#c4b5fd" : "#4c1d95") : variant === "supervisor" ? ($isDarkMode ? "#4ade80" : "#16a34a") : ($isDarkMode ? "#cbd5e1" : "#475569")};
// // // // `;

// // // // const CalcLine = styled.div`
// // // //   font-size: 0.95rem; font-weight: ${({ strong }) => strong ? 800 : 500};
// // // //   color: ${({ variant, $isDarkMode }) => variant === "admin" ? ($isDarkMode ? "#ddd6fe" : "#5b21b6") : variant === "supervisor" ? ($isDarkMode ? "#86efac" : "#15803d") : ($isDarkMode ? "#f8fafc" : "#334155")};
// // // // `;

// // // // /* ================= ACTIONS & STATES ================= */
// // // // const ActionWrap = styled.div` display: flex; width: 100%; margin-top: 32px; `;

// // // // const SubmitButton = styled.button`
// // // //   appearance: none; border: none; outline: none; border-radius: 16px; padding: 18px 36px; width: 100%;
// // // //   background: ${({ disabled, success }) => disabled && !success ? "linear-gradient(135deg, #94a3b8, #cbd5e1)" : "linear-gradient(135deg, #16a34a, #22c55e)"}; 
// // // //   color: white; font-size: 1.1rem; font-weight: 800; cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
// // // //   box-shadow: ${({ disabled, success }) => disabled && !success ? "none" : "0 14px 28px rgba(34, 197, 94, 0.25)"}; transition: all 0.2s ease;
// // // //   &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 18px 30px rgba(34, 197, 94, 0.3); }
// // // // `;

// // // // const CenterState = styled.div` min-height: 50vh; display: grid; place-items: center; `;
// // // // const StateCard = styled.div` width: min(460px, 100%); background: var(--card-bg); border: 1px solid var(--border); border-radius: 24px; padding: 32px; text-align: center; box-shadow: var(--shadow-md); `;
// // // // const Spinner = styled.div` width: 46px; height: 46px; margin: 0 auto 18px; border-radius: 50%; border: 4px solid var(--border); border-top-color: #16a34a; animation: spin 0.8s linear infinite; @keyframes spin { to { transform: rotate(360deg); } } `;
// // // // const StateTitle = styled.h3` margin: 0 0 8px; font-size: 1.2rem; color: var(--text-main); font-weight: 800; `;
// // // // const StateText = styled.p` margin: 10px 0 0; color: var(--text-soft); line-height: 1.6; `;

// // // // /* ================= COMPONENT ================= */
// // // // const AdminAppraisalForm = ({ user, collapsed, setCollapsed }) => {
// // // //   const { isDarkMode } = useTheme();
// // // //   const { userId } = useParams(); // Expected to be passed in route /admin/goals/:userId
// // // //   const navigate = useNavigate();

// // // //   const [loading, setLoading] = useState(true);
// // // //   const [saving, setSaving] = useState(false);
// // // //   const [savedRecently, setSavedRecently] = useState(false);
  
// // // //   const [staffInfo, setStaffInfo] = useState(null);
// // // //   const [appraisalId, setAppraisalId] = useState(null);
// // // //   const [section4Data, setSection4Data] = useState([]);
  
// // // //   const availableMonths = useMemo(() => generateMonthOptions(), []);
  
// // // //   // Track selected month explicitly for this Admin view
// // // //   const [selectedMonth, setSelectedMonth] = useState(
// // // //     localStorage.getItem("adminViewMonth") || getCurrentMonthName()
// // // //   );

// // // //   useEffect(() => {
// // // //     localStorage.setItem("adminViewMonth", selectedMonth);
// // // //   }, [selectedMonth]);

// // // //   // Fetch the specific user's appraisal for the selected month
// // // //   useEffect(() => {
// // // //     const fetchAppraisal = async () => {
// // // //       if (!userId) return;
// // // //       setLoading(true);
// // // //       try {
// // // //         // Step 1: Find the appraisal document that matches the userId AND the selectedMonth
// // // //         // (Assuming you create this specific lookup route, or we filter an 'all' route)
// // // //         // For standard setup, let's assume an endpoint exists: /appraisal/admin/user/:userId/:period
// // // //         const res = await api.get(`/appraisal/admin/user/${userId}/${selectedMonth}`);
        
// // // //         if (res.data.success && res.data.data) {
// // // //           const appraisal = res.data.data;
// // // //           setAppraisalId(appraisal._id);
// // // //           setStaffInfo(appraisal.userId || appraisal.user || appraisal.userDetails || {});
          
// // // //           // Re-map the compliance items to ensure we have the full default list, merging existing data
// // // //           const mergedData = complianceItems.map(defaultItem => {
// // // //             const existing = (appraisal.section4 || []).find(dbItem => dbItem.attribute === defaultItem.attribute);
// // // //             return {
// // // //               ...defaultItem,
// // // //               staffScore: existing?.staffScore || "",
// // // //               supervisorScore: existing?.supervisorScore || "",
// // // //               staffComments: existing?.staffComments || "",
// // // //               supervisorComments: existing?.supervisorComments || "",
// // // //               // 🔥 NEW: Admin Fields
// // // //               adminScore: existing?.adminScore || "",
// // // //               adminComments: existing?.adminComments || "",
// // // //             };
// // // //           });
// // // //           setSection4Data(mergedData);
// // // //         } else {
// // // //           // If no appraisal exists for this month, reset the form
// // // //           setAppraisalId(null);
// // // //           setStaffInfo(null);
// // // //           setSection4Data(complianceItems.map(item => ({ ...item, staffScore: "", supervisorScore: "", adminScore: "", adminComments: "" })));
// // // //         }
// // // //       } catch (err) {
// // // //         console.error("Error fetching appraisal:", err);
// // // //         setAppraisalId(null);
// // // //       } finally {
// // // //         setLoading(false);
// // // //       }
// // // //     };
// // // //     fetchAppraisal();
// // // //   }, [userId, selectedMonth]);

// // // //   // Handle Admin Input Changes
// // // //   const handleAdminScore = (index, value) => {
// // // //     setSection4Data(prev => prev.map((item, i) => i === index ? { ...item, adminScore: value } : item));
// // // //   };

// // // //   const handleAdminComment = (index, value) => {
// // // //     setSection4Data(prev => prev.map((item, i) => i === index ? { ...item, adminComments: value } : item));
// // // //   };

// // // //   // Calculate Scores dynamically
// // // //   const calculateScores = () => {
// // // //     const calcGroup = (scoreKey, maxScore = 10, bonusIndex = 15) => {
// // // //       const validScores = section4Data.filter((item, i) => i < 15).map(item => parseScoreValue(item[scoreKey])).filter(s => s !== null);
// // // //       const bonusScore = parseScoreValue(section4Data[bonusIndex]?.[scoreKey]) || 0;
      
// // // //       if (validScores.length === 0) return { total: 0, completed: 0, rawAvg: 0 };
      
// // // //       const sum = validScores.reduce((acc, val) => acc + val, 0) + bonusScore;
// // // //       const avg = sum / validScores.length;
// // // //       let total = (avg / 5) * maxScore;
// // // //       total = Math.min(total, maxScore); // Cap at max
      
// // // //       return { total: total.toFixed(1), completed: validScores.length + (bonusScore > 0 ? 1 : 0), rawAvg: avg.toFixed(2) };
// // // //     };

// // // //     return {
// // // //       staff: calcGroup('staffScore'),
// // // //       supervisor: calcGroup('supervisorScore'),
// // // //       admin: calcGroup('adminScore')
// // // //     };
// // // //   };

// // // //   const scores = calculateScores();

// // // //   const handleSave = async () => {
// // // //     if (!appraisalId) return alert("No appraisal document found to update for this month.");
    
// // // //     setSaving(true);
// // // //     try {
// // // //       // Create the payload matching your backend route requirements
// // // //       const payload = {
// // // //         section4: section4Data,
// // // //         summary: {
// // // //           section4: parseFloat(scores.admin.total) || 0, // Using Admin score as the final authority
// // // //           hodOverallComments: "" // Optional: Add a master comment field if needed
// // // //         }
// // // //       };

// // // //       await api.put(`/appraisal/admin-score/${appraisalId}`, payload);
      
// // // //       setSavedRecently(true);
// // // //       setTimeout(() => setSavedRecently(false), 3000);
// // // //     } catch (error) {
// // // //       console.error(error);
// // // //       alert("Failed to save Admin assessment.");
// // // //     } finally {
// // // //       setSaving(false);
// // // //     }
// // // //   };

// // // //   if (loading) {
// // // //     return (
// // // //       <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
// // // //         <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
// // // //         <Main>
// // // //           <CenterState>
// // // //             <StateCard>
// // // //               <Spinner />
// // // //               <StateTitle>Accessing Records...</StateTitle>
// // // //               <StateText>Retrieving compliance logs for {selectedMonth}.</StateText>
// // // //             </StateCard>
// // // //           </CenterState>
// // // //         </Main>
// // // //       </Container>
// // // //     );
// // // //   }

// // // //   return (
// // // //     <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
// // // //       <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
// // // //       <DashboardHeader user={user} collapsed={collapsed} />

// // // //       <Main>
// // // //         <BackButton onClick={() => navigate('/admin/dashboard')}>
// // // //           <FaArrowLeft /> Back to Directory
// // // //         </BackButton>

// // // //         <SectionCard>
// // // //           <HeaderRow>
// // // //             <SectionTitle><FaShieldAlt style={{color: '#16a34a'}}/> Compliance Oversight</SectionTitle>
// // // //             <GlobalMonthSelect $isDarkMode={isDarkMode} value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
// // // //               {availableMonths.map(m => <option key={m} value={m}>{m}</option>)}
// // // //             </GlobalMonthSelect>
// // // //           </HeaderRow>
          
// // // //           <Subtitle>Review the compliance adherence scores for this specific staff member. You may override or finalize the assessment using the Admin Score column.</Subtitle>

// // // //           {staffInfo?.firstName && (
// // // //             <StaffInfoBox $isDarkMode={isDarkMode} style={{ marginTop: '20px' }}>
// // // //               <StaffName $isDarkMode={isDarkMode}>{staffInfo.firstName} {staffInfo.surname}</StaffName>
// // // //               <StaffRole>{staffInfo.unit || 'No Unit Assigned'}</StaffRole>
// // // //             </StaffInfoBox>
// // // //           )}

// // // //           {!appraisalId ? (
// // // //             <CenterState style={{ minHeight: '30vh' }}>
// // // //               <StateTitle>No Record Found</StateTitle>
// // // //               <StateText>This user has not initiated an appraisal draft for {selectedMonth}.</StateText>
// // // //             </CenterState>
// // // //           ) : (
// // // //             <>
// // // //               <TableWrapper>
// // // //                 <Table>
// // // //                   <colgroup>
// // // //                     <col style={{ width: "4%" }} />
// // // //                     <col style={{ width: "16%" }} />
// // // //                     <col style={{ width: "24%" }} />
// // // //                     <col style={{ width: "8%" }} />
// // // //                     <col style={{ width: "8%" }} />
// // // //                     <col style={{ width: "12%" }} />
// // // //                     <col style={{ width: "28%" }} />
// // // //                   </colgroup>
// // // //                   <thead>
// // // //                     <tr>
// // // //                       <Th $isDarkMode={isDarkMode}>S/N</Th>
// // // //                       <Th $isDarkMode={isDarkMode}>Protocol</Th>
// // // //                       <Th $isDarkMode={isDarkMode}>Description</Th>
// // // //                       <Th $isDarkMode={isDarkMode}>Staff<br/>Score</Th>
// // // //                       <Th $isDarkMode={isDarkMode}>Supv.<br/>Score</Th>
// // // //                       <Th $isDarkMode={isDarkMode}>Admin Score</Th>
// // // //                       <Th $isDarkMode={isDarkMode}>Admin Comments</Th>
// // // //                     </tr>
// // // //                   </thead>
// // // //                   <tbody>
// // // //                     {section4Data.map((item, index) => (
// // // //                       <tr key={index}>
// // // //                         <Td><Serial $isDarkMode={isDarkMode}>{index + 1}</Serial></Td>
// // // //                         <Td><AttributeBox $isDarkMode={isDarkMode}>{item.attribute}</AttributeBox></Td>
// // // //                         <Td><DisabledInput $isDarkMode={isDarkMode}>{item.description}</DisabledInput></Td>
// // // //                         <Td><SmallScore $isDarkMode={isDarkMode}>{scoreValue(item.staffScore)}</SmallScore></Td>
// // // //                         <Td><SmallScore $isDarkMode={isDarkMode}>{scoreValue(item.supervisorScore)}</SmallScore></Td>
// // // //                         <Td>
// // // //                           <Select value={item.adminScore ?? ""} onChange={(e) => handleAdminScore(index, e.target.value)} $isDarkMode={isDarkMode}>
// // // //                             {ratingScale.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
// // // //                           </Select>
// // // //                         </Td>
// // // //                         <Td>
// // // //                           <Textarea 
// // // //                             value={item.adminComments || ""}
// // // //                             onChange={(e) => handleAdminComment(index, e.target.value)}
// // // //                             placeholder="Add administrative feedback..."
// // // //                             $isDarkMode={isDarkMode}
// // // //                           />
// // // //                         </Td>
// // // //                       </tr>
// // // //                     ))}
// // // //                   </tbody>
// // // //                 </Table>
// // // //               </TableWrapper>

// // // //               <CalcGrid>
// // // //                 <CalcBox variant="staff" $isDarkMode={isDarkMode}>
// // // //                   <CalcTitle variant="staff" $isDarkMode={isDarkMode}>Staff Self-Assessment</CalcTitle>
// // // //                   <CalcLine variant="staff" $isDarkMode={isDarkMode}>Items Scored: {scores.staff.completed}</CalcLine>
// // // //                   <CalcLine variant="staff" $isDarkMode={isDarkMode}>Average: {scores.staff.rawAvg}</CalcLine>
// // // //                   <CalcLine variant="staff" $isDarkMode={isDarkMode} strong>TOTAL: {scores.staff.total} / 10</CalcLine>
// // // //                 </CalcBox>
                
// // // //                 <CalcBox variant="supervisor" $isDarkMode={isDarkMode}>
// // // //                   <CalcTitle variant="supervisor" $isDarkMode={isDarkMode}>Supervisor Assessment</CalcTitle>
// // // //                   <CalcLine variant="supervisor" $isDarkMode={isDarkMode}>Items Scored: {scores.supervisor.completed}</CalcLine>
// // // //                   <CalcLine variant="supervisor" $isDarkMode={isDarkMode}>Average: {scores.supervisor.rawAvg}</CalcLine>
// // // //                   <CalcLine variant="supervisor" $isDarkMode={isDarkMode} strong>TOTAL: {scores.supervisor.total} / 10</CalcLine>
// // // //                 </CalcBox>
                
// // // //                 <CalcBox variant="admin" $isDarkMode={isDarkMode}>
// // // //                   <CalcTitle variant="admin" $isDarkMode={isDarkMode}>Admin Final Assessment</CalcTitle>
// // // //                   <CalcLine variant="admin" $isDarkMode={isDarkMode}>Items Scored: {scores.admin.completed}</CalcLine>
// // // //                   <CalcLine variant="admin" $isDarkMode={isDarkMode}>Average: {scores.admin.rawAvg}</CalcLine>
// // // //                   <CalcLine variant="admin" $isDarkMode={isDarkMode} strong>TOTAL: {scores.admin.total} / 10</CalcLine>
// // // //                 </CalcBox>
// // // //               </CalcGrid>

// // // //               <ActionWrap>
// // // //                 <SubmitButton onClick={handleSave} disabled={saving || savedRecently} success={savedRecently}>
// // // //                   {saving ? "Processing..." : savedRecently ? "Oversight Logged Successfully! ✓" : "Commit Admin Evaluation"}
// // // //                 </SubmitButton>
// // // //               </ActionWrap>
// // // //             </>
// // // //           )}
// // // //         </SectionCard>
// // // //       </Main>
// // // //       <Footer />
// // // //     </Container>
// // // //   );
// // // // };

// // // // export default AdminAppraisalForm;















// // // import React, { useEffect, useMemo, useState } from "react";
// // // import styled from "styled-components";
// // // import { useParams, useNavigate } from "react-router-dom";
// // // import { FaArrowLeft, FaShieldAlt } from "react-icons/fa";
// // // import NavBarSuper from "./NavBarSuper";
// // // import DashboardHeader from "./DashboardHeader";
// // // import Footer from "./Footer";
// // // import api from "../api";
// // // import { useTheme } from "../App"; // 🔥 Import the global theme hook

// // // /* ================= HELPERS ================= */
// // // const getCurrentMonthName = () => {
// // //   const date = new Date();
// // //   return date.toLocaleString("default", { month: "long", year: "numeric" });
// // // };

// // // const generateMonthOptions = () => {
// // //   const months = [];
// // //   const date = new Date();
// // //   date.setMonth(date.getMonth() - 3); 
// // //   for (let i = 0; i < 12; i++) {
// // //     months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
// // //     date.setMonth(date.getMonth() + 1);
// // //   }
// // //   return months;
// // // };

// // // const parseScoreValue = (value) => {
// // //   if (value === "N/A" || value === "" || value == null) return null;
// // //   const num = Number(value);
// // //   return Number.isNaN(num) ? null : num;
// // // };

// // // const ScoreValue = (value) => {
// // //   if (value === "N/A" || value === "" || value == null) return null;
// // //   const num = Number(value);
// // //   return Number.isNaN(num) ? null : num;
// // // };

// // // const formatScore = (value) => Number(value || 0).toFixed(1);

// // // const complianceItems = [
// // //   { attribute: "Feedback", description: "Measures the progress and status of work with the use of relevant tools. Gives quality and consistent information on assigned tasks." },
// // //   { attribute: "Responsiveness to official communication", description: "Is reachable and responsive on Kingschat and official communication platforms." },
// // //   { attribute: "Care and Maintenance of office space and equipment", description: "Consistently maintains a clean, tidy and orderly office space. Takes good care of all equipment, keeping them in optimal working condition." },
// // //   { attribute: "Ministry Programs", description: "Participates in Ministry Global Programs such as Your Loveworld, GDOP, etc." },
// // //   { attribute: "Church Services and Meetings", description: "Consistently and punctually at Sunday and Wednesday Church Services, Prayer Services." },
// // //   { attribute: "Monthly Goals", description: "Promptly submits monthly goals before 1st 12.00am of each month." },
// // //   { attribute: "Weekly Goals", description: "Promptly submits weekly goals on or before Saturday 11.59pm." },
// // //   { attribute: "Weekly Reporting", description: "Promptly submits all weekly reports on or before Saturday 11:59pm." },
// // //   { attribute: "Performance Reporting", description: "Promptly submits performance appraisal form on or before 1st of each month." },
// // //   { attribute: "Online publicity and awareness creation", description: "Consistently publicizes, promotes and creates awareness of departmental products and activities online and physically as required. (Free type)" },
// // //   { attribute: "Staff Trainings", description: "Consistently and punctually at Staff Training Programs and products, STDL, other Ministry trainings for staff." },
// // //   { attribute: "Office Attendance", description: "Consistently and punctually at the office." },
// // //   { attribute: "Office Prayer Meetings", description: "Consistently and punctually at Staff Office Prayer Meetings (onsite and online)." },
// // //   { attribute: "Staff Chapel & Care Group Meetings", description: "Consistently and punctually at Staff Chapel Services & Staff Care Group Meetings."},
// // //   { attribute: "Uniforms", description: "Wears clean, proper and appropriate uniforms." },
// // // ];

// // // const ratingScale = [
// // //   { value: "", label: "Select..." },
// // //   { value: "N/A", label: "N/A - Not applicable" },
// // //   { value: "0", label: "0 - Not evident" },
// // //   { value: "1", label: "1 - Unsatisfactory" },
// // //   { value: "2", label: "2 - Below expectation" },
// // //   { value: "3", label: "3 - Met some expectation" },
// // //   { value: "4", label: "4 - Met expectation" },
// // //   { value: "5", label: "5 - Surpassed expectation" },
// // // ];

// // // /* ================= PAGE LAYOUT & THEME VARIABLES ================= */
// // // const Container = styled.div`
// // //   --sidebar-expanded: 260px;
// // //   --sidebar-collapsed: 90px;
  
// // //   /* 🔥 THEME VARIABLES 🔥 */
// // //   --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
// // //   --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.96)'};
// // //   --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
// // //   --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
// // //   --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
// // //   --input-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'};
// // //   --table-header-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#f0fdf4'};
// // //   --table-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#bbf7d0'};

// // //   min-height: 100vh;
// // //   background: var(--page-bg);
// // //   color: var(--text-main);
// // //   margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
// // //   transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;

// // //   @media (max-width: 1023px) { margin-left: 0; }
// // // `;

// // // const Main = styled.main`
// // //   width: min(1450px, calc(100% - 32px)); margin: 0 auto; padding: 94px 0 80px;
// // //   @media (max-width: 1023px) { width: min(100%, calc(100% - 24px)); padding-top: 86px; }
// // // `;

// // // /* ================= COMPONENTS ================= */
// // // const BackButton = styled.button` 
// // //   display: inline-flex; align-items: center; gap: 8px; background: none; border: none;
// // //   color: #16a34a; font-weight: 800; font-size: 1rem; cursor: pointer; transition: transform 0.2s ease; padding: 0; margin-bottom: 24px;
// // //   &:hover { transform: translateX(-4px); text-decoration: underline; }
// // // `;

// // // const SectionCard = styled.section`
// // //   background: var(--card-bg); border: 1px solid var(--border); border-radius: 28px; padding: 32px; box-shadow: 0 12px 30px rgba(0,0,0,0.05); margin-bottom: 32px;
// // //   transition: background 0.3s ease, border 0.3s ease;
// // //   @media (max-width: 768px) { padding: 20px; border-radius: 22px; }
// // // `;

// // // const HeaderRow = styled.div`
// // //   display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 16px; margin-bottom: 24px;
// // // `;

// // // const SectionTitle = styled.h2` margin: 0; font-size: clamp(1.2rem, 1rem + 0.6vw, 1.6rem); font-weight: 900; color: var(--text-main); display: flex; align-items: center; gap: 12px; `;

// // // const GlobalMonthSelect = styled.select`
// // //   padding: 8px 16px; border-radius: 12px; border: 2px solid ${({ $isDarkMode }) => $isDarkMode ? '#22c55e' : '#86efac'}; 
// // //   font-size: 1.1rem; font-weight: 800; color: #16a34a; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.1)' : '#f0fdf4'}; 
// // //   outline: none; cursor: pointer; transition: all 0.2s;
// // //   &:focus { border-color: #16a34a; box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.1); }
// // // `;

// // // const Subtitle = styled.p` color: var(--text-soft); margin: 0; font-size: 0.95rem; line-height: 1.6; max-width: 800px; `;

// // // const StaffInfoBox = styled.div`
// // //   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.05)' : '#eff6ff'};
// // //   border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#1e3a8a' : '#bfdbfe'};
// // //   padding: 16px 20px; border-radius: 16px; margin-bottom: 24px; display: inline-flex; align-items: center; gap: 16px; flex-wrap: wrap;
// // // `;

// // // const StaffName = styled.div` font-size: 1.1rem; font-weight: 800; color: ${({ $isDarkMode }) => $isDarkMode ? '#93c5fd' : '#1e40af'}; `;
// // // const StaffRole = styled.div` font-size: 0.9rem; font-weight: 600; color: var(--text-soft); background: var(--card-bg); padding: 4px 10px; border-radius: 999px; border: 1px solid var(--border); `;

// // // /* ================= TABLE STYLES ================= */
// // // const TableWrapper = styled.div`
// // //   width: 100%; overflow-x: auto; border-radius: 14px; border: 1px solid var(--table-border);
// // // `;

// // // const Table = styled.table`
// // //   width: 100%; border-collapse: separate; border-spacing: 0; background: transparent; table-layout: fixed; min-width: 1000px;
// // // `;

// // // const Th = styled.th`
// // //   background: var(--table-header-bg); padding: 14px 10px; text-align: left; font-size: 12px; font-weight: 800; 
// // //   color: ${({ $isDarkMode }) => $isDarkMode ? '#86efac' : '#15803d'}; border-bottom: 1px solid var(--table-border); vertical-align: middle;
// // //   &:first-child { border-top-left-radius: 14px; } &:last-child { border-top-right-radius: 14px; }
// // // `;

// // // const Td = styled.td`
// // //   padding: 14px 10px; border-bottom: 1px solid var(--table-border); vertical-align: top;
// // // `;

// // // const Serial = styled.div`
// // //   width: 28px; height: 28px; display: grid; place-items: center; border-radius: 50%; 
// // //   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.15)' : '#f0fdf4'}; 
// // //   color: ${({ $isDarkMode }) => $isDarkMode ? '#86efac' : '#15803d'}; font-weight: 800; font-size: 0.85rem;
// // // `;

// // // const AttributeBox = styled.div`
// // //   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.05)' : '#f0fdf4'}; 
// // //   padding: 8px 12px; border-left: 4px solid #22c55e; border-radius: 8px; font-weight: 700; 
// // //   color: ${({ $isDarkMode }) => $isDarkMode ? '#bbf7d0' : '#14532d'}; font-size: 0.85rem; word-wrap: break-word;
// // // `;

// // // const DisabledInput = styled.div`
// // //   min-height: 32px; border: 1px solid var(--input-border); background: ${({ $isDarkMode }) => $isDarkMode ? 'var(--input-bg)' : '#f8fafc'};
// // //   color: var(--text-soft); border-radius: 6px; padding: 8px; line-height: 1.4; white-space: pre-wrap; font-size: 13px;
// // // `;

// // // const SmallScore = styled.div`
// // //   width: 36px; height: 36px; display: inline-flex; align-items: center; justify-content: center; border-radius: 6px;
// // //   border: 1px solid var(--input-border); background: ${({ $isDarkMode }) => $isDarkMode ? 'var(--input-bg)' : '#f8fafc'}; 
// // //   font-weight: 800; color: var(--text-soft); font-size: 13px;
// // // `;

// // // const Select = styled.select`
// // //   width: 100%; padding: 10px; border-radius: 8px; border: 2px solid ${({ $isDarkMode }) => $isDarkMode ? '#14532d' : '#86efac'}; 
// // //   font-size: 13px; font-weight: 700; color: var(--text-main); background: var(--input-bg); outline: none; transition: all 0.2s;
// // //   &:focus { border-color: #22c55e; box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15); }
// // // `;

// // // const Textarea = styled.textarea`
// // //   width: 100%; min-height: 60px; padding: 10px; border: 1px solid var(--input-border); border-radius: 8px; resize: vertical; 
// // //   font-size: 13px; line-height: 1.4; background: var(--input-bg); color: var(--text-main); outline: none; box-sizing: border-box;
// // //   &:focus { border-color: #22c55e; box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15); }
// // // `;

// // // /* ================= SCORE CALCULATION BOXES ================= */
// // // const CalcGrid = styled.div` display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-top: 24px; @media (max-width: 900px) { grid-template-columns: 1fr; } `;

// // // const CalcBox = styled.div`
// // //   padding: 24px; border-radius: 20px; border-left: 5px solid; line-height: 1.75; box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
// // //   background: ${({ variant, $isDarkMode }) => 
// // //     variant === "admin" ? ($isDarkMode ? 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)' : "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)") :
// // //     variant === "supervisor" ? ($isDarkMode ? 'linear-gradient(135deg, #064e3b 0%, #14532d 100%)' : "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)") :
// // //     ($isDarkMode ? 'linear-gradient(135deg, #1e293b 0%, #334155 100%)' : "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)")
// // //   };
// // //   border-left-color: ${({ variant }) => variant === "admin" ? "#8b5cf6" : variant === "supervisor" ? "#16a34a" : "#64748b"};
// // // `;

// // // const CalcTitle = styled.div`
// // //   font-size: 1.05rem; font-weight: 900; margin-bottom: 8px;
// // //   color: ${({ variant, $isDarkMode }) => variant === "admin" ? ($isDarkMode ? "#c4b5fd" : "#4c1d95") : variant === "supervisor" ? ($isDarkMode ? "#4ade80" : "#16a34a") : ($isDarkMode ? "#cbd5e1" : "#475569")};
// // // `;

// // // const CalcLine = styled.div`
// // //   font-size: 0.95rem; font-weight: ${({ strong }) => strong ? 800 : 500};
// // //   color: ${({ variant, $isDarkMode }) => variant === "admin" ? ($isDarkMode ? "#ddd6fe" : "#5b21b6") : variant === "supervisor" ? ($isDarkMode ? "#86efac" : "#15803d") : ($isDarkMode ? "#f8fafc" : "#334155")};
// // // `;

// // // /* ================= ACTIONS & STATES ================= */
// // // const ActionWrap = styled.div` display: flex; width: 100%; margin-top: 32px; `;

// // // const SubmitButton = styled.button`
// // //   appearance: none; border: none; outline: none; border-radius: 16px; padding: 18px 36px; width: 100%;
// // //   background: ${({ disabled, success }) => disabled && !success ? "linear-gradient(135deg, #94a3b8, #cbd5e1)" : "linear-gradient(135deg, #16a34a, #22c55e)"}; 
// // //   color: white; font-size: 1.1rem; font-weight: 800; cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
// // //   box-shadow: ${({ disabled, success }) => disabled && !success ? "none" : "0 14px 28px rgba(34, 197, 94, 0.25)"}; transition: all 0.2s ease;
// // //   &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 18px 30px rgba(34, 197, 94, 0.3); }
// // // `;

// // // const CenterState = styled.div` min-height: 50vh; display: grid; place-items: center; `;
// // // const StateCard = styled.div` width: min(460px, 100%); background: var(--card-bg); border: 1px solid var(--border); border-radius: 24px; padding: 32px; text-align: center; box-shadow: var(--shadow-md); `;
// // // const Spinner = styled.div` width: 46px; height: 46px; margin: 0 auto 18px; border-radius: 50%; border: 4px solid var(--border); border-top-color: #16a34a; animation: spin 0.8s linear infinite; @keyframes spin { to { transform: rotate(360deg); } } `;
// // // const StateTitle = styled.h3` margin: 0 0 8px; font-size: 1.2rem; color: var(--text-main); font-weight: 800; `;
// // // const StateText = styled.p` margin: 10px 0 0; color: var(--text-soft); line-height: 1.6; `;

// // // /* ================= COMPONENT ================= */
// // // const AdminAppraisalForm = ({ user, collapsed, setCollapsed }) => {
// // //   const { isDarkMode } = useTheme();
// // //   const { userId } = useParams(); // Expected to be passed in route /admin/goals/:userId
// // //   const navigate = useNavigate();

// // //   const [loading, setLoading] = useState(true);
// // //   const [saving, setSaving] = useState(false);
// // //   const [savedRecently, setSavedRecently] = useState(false);
  
// // //   const [staffInfo, setStaffInfo] = useState(null);
// // //   const [appraisalId, setAppraisalId] = useState(null);
// // //   const [section4Data, setSection4Data] = useState([]);
  
// // //   const availableMonths = useMemo(() => generateMonthOptions(), []);
  
// // //   // Track selected month explicitly for this Admin view
// // //   const [selectedMonth, setSelectedMonth] = useState(
// // //     localStorage.getItem("adminViewMonth") || getCurrentMonthName()
// // //   );

// // //   useEffect(() => {
// // //     localStorage.setItem("adminViewMonth", selectedMonth);
// // //   }, [selectedMonth]);

// // //   // Fetch the specific user's appraisal for the selected month
// // //   useEffect(() => {
// // //     const fetchAppraisal = async () => {
// // //       if (!userId) return;
// // //       setLoading(true);
// // //       try {
// // //         // Step 1: Find the appraisal document that matches the userId AND the selectedMonth
// // //         // (Assuming you create this specific lookup route, or we filter an 'all' route)
// // //         // For standard setup, let's assume an endpoint exists: /appraisal/admin/user/:userId/:period
// // //         const res = await api.get(`/appraisal/admin/user/${userId}/${selectedMonth}`);
        
// // //         if (res.data.success && res.data.data) {
// // //           const appraisal = res.data.data;
// // //           setAppraisalId(appraisal._id);
// // //           setStaffInfo(appraisal.userId || appraisal.user || appraisal.userDetails || {});
          
// // //           // Re-map the compliance items to ensure we have the full default list, merging existing data
// // //           const mergedData = complianceItems.map(defaultItem => {
// // //             const existing = (appraisal.section4 || []).find(dbItem => dbItem.attribute === defaultItem.attribute);
// // //             return {
// // //               ...defaultItem,
// // //               staffScore: existing?.staffScore || "",
// // //               supervisorScore: existing?.supervisorScore || "",
// // //               staffComments: existing?.staffComments || "",
// // //               supervisorComments: existing?.supervisorComments || "",
// // //               // 🔥 NEW: Admin Fields
// // //               adminScore: existing?.adminScore || "",
// // //               adminComments: existing?.adminComments || "",
// // //             };
// // //           });
// // //           setSection4Data(mergedData);
// // //         } else {
// // //           // If no appraisal exists for this month, reset the form
// // //           setAppraisalId(null);
// // //           setStaffInfo(null);
// // //           setSection4Data(complianceItems.map(item => ({ ...item, staffScore: "", supervisorScore: "", adminScore: "", adminComments: "" })));
// // //         }
// // //       } catch (err) {
// // //         console.error("Error fetching appraisal:", err);
// // //         setAppraisalId(null);
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };
// // //     fetchAppraisal();
// // //   }, [userId, selectedMonth]);

// // //   // Handle Admin Input Changes
// // //   const handleAdminScore = (index, value) => {
// // //     setSection4Data(prev => prev.map((item, i) => i === index ? { ...item, adminScore: value } : item));
// // //   };

// // //   const handleAdminComment = (index, value) => {
// // //     setSection4Data(prev => prev.map((item, i) => i === index ? { ...item, adminComments: value } : item));
// // //   };

// // //   // Calculate Scores dynamically
// // //   const calculateScores = () => {
// // //     const calcGroup = (scoreKey, maxScore = 10, bonusIndex = 15) => {
// // //       const validScores = section4Data.filter((item, i) => i < 15).map(item => parseScoreValue(item[scoreKey])).filter(s => s !== null);
// // //       const bonusScore = parseScoreValue(section4Data[bonusIndex]?.[scoreKey]) || 0;
      
// // //       if (validScores.length === 0) return { total: 0, completed: 0, rawAvg: 0 };
      
// // //       const sum = validScores.reduce((acc, val) => acc + val, 0) + bonusScore;
// // //       const avg = sum / validScores.length;
// // //       let total = (avg / 5) * maxScore;
// // //       total = Math.min(total, maxScore); // Cap at max
      
// // //       return { total: total.toFixed(1), completed: validScores.length + (bonusScore > 0 ? 1 : 0), rawAvg: avg.toFixed(2) };
// // //     };

// // //     return {
// // //       staff: calcGroup('staffScore'),
// // //       supervisor: calcGroup('supervisorScore'),
// // //       admin: calcGroup('adminScore')
// // //     };
// // //   };

// // //   const scores = calculateScores();

// // //   const handleSave = async () => {
// // //     if (!appraisalId) return alert("No appraisal document found to update for this month.");
    
// // //     setSaving(true);
// // //     try {
// // //       // Create the payload matching your backend route requirements
// // //       const payload = {
// // //         section4: section4Data,
// // //         summary: {
// // //           section4: parseFloat(scores.admin.total) || 0, // Using Admin score as the final authority
// // //           hodOverallComments: "" // Optional: Add a master comment field if needed
// // //         }
// // //       };

// // //       await api.put(`/appraisal/admin-score/${appraisalId}`, payload);
      
// // //       setSavedRecently(true);
// // //       setTimeout(() => setSavedRecently(false), 3000);
// // //     } catch (error) {
// // //       console.error(error);
// // //       alert("Failed to save Admin assessment.");
// // //     } finally {
// // //       setSaving(false);
// // //     }
// // //   };

// // //   if (loading) {
// // //     return (
// // //       <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
// // //         <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
// // //         <Main>
// // //           <CenterState>
// // //             <StateCard>
// // //               <Spinner />
// // //               <StateTitle>Accessing Records...</StateTitle>
// // //               <StateText>Retrieving compliance logs for {selectedMonth}.</StateText>
// // //             </StateCard>
// // //           </CenterState>
// // //         </Main>
// // //       </Container>
// // //     );
// // //   }

// // //   return (
// // //     // 🔥 PASS THE THEME STATE TO THE CONTAINER 🔥
// // //     <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
// // //       <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
// // //       <DashboardHeader user={user} collapsed={collapsed} />

// // //       <Main>
// // //         <BackButton onClick={() => navigate('/admin/dashboard')}>
// // //           <FaArrowLeft /> Back to Directory
// // //         </BackButton>

// // //         <SectionCard>
// // //           <HeaderRow>
// // //             <SectionTitle><FaShieldAlt style={{color: '#16a34a'}}/> Compliance Oversight</SectionTitle>
// // //             <GlobalMonthSelect $isDarkMode={isDarkMode} value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
// // //               {availableMonths.map(m => <option key={m} value={m}>{m}</option>)}
// // //             </GlobalMonthSelect>
// // //           </HeaderRow>
          
// // //           <Subtitle>Review the compliance adherence scores for this specific staff member. You may override or finalize the assessment using the Admin Score column.</Subtitle>

// // //           {staffInfo?.firstName && (
// // //             <StaffInfoBox $isDarkMode={isDarkMode} style={{ marginTop: '20px' }}>
// // //               <StaffName $isDarkMode={isDarkMode}>{staffInfo.firstName} {staffInfo.surname}</StaffName>
// // //               <StaffRole>{staffInfo.unit || 'No Unit Assigned'}</StaffRole>
// // //             </StaffInfoBox>
// // //           )}

// // //           {!appraisalId ? (
// // //             <CenterState style={{ minHeight: '30vh' }}>
// // //               <StateTitle>No Record Found</StateTitle>
// // //               <StateText>This user has not initiated an appraisal draft for {selectedMonth}.</StateText>
// // //             </CenterState>
// // //           ) : (
// // //             <>
// // //               <TableWrapper>
// // //                 <Table>
// // //                   <colgroup>
// // //                     <col style={{ width: "4%" }} />
// // //                     <col style={{ width: "16%" }} />
// // //                     <col style={{ width: "24%" }} />
// // //                     <col style={{ width: "8%" }} />
// // //                     <col style={{ width: "8%" }} />
// // //                     <col style={{ width: "12%" }} />
// // //                     <col style={{ width: "28%" }} />
// // //                   </colgroup>
// // //                   <thead>
// // //                     <tr>
// // //                       <Th $isDarkMode={isDarkMode}>S/N</Th>
// // //                       <Th $isDarkMode={isDarkMode}>Protocol</Th>
// // //                       <Th $isDarkMode={isDarkMode}>Description</Th>
// // //                       <Th $isDarkMode={isDarkMode}>Staff<br/>Score</Th>
// // //                       <Th $isDarkMode={isDarkMode}>Supv.<br/>Score</Th>
// // //                       <Th $isDarkMode={isDarkMode}>Admin Score</Th>
// // //                       <Th $isDarkMode={isDarkMode}>Admin Comments</Th>
// // //                     </tr>
// // //                   </thead>
// // //                   <tbody>
// // //                     {section4Data.map((item, index) => (
// // //                       <tr key={index}>
// // //                         <Td><Serial $isDarkMode={isDarkMode}>{index + 1}</Serial></Td>
// // //                         <Td><AttributeBox $isDarkMode={isDarkMode}>{item.attribute}</AttributeBox></Td>
// // //                         <Td><DisabledInput $isDarkMode={isDarkMode}>{item.description}</DisabledInput></Td>
// // //                         <Td><SmallScore $isDarkMode={isDarkMode}>{ScoreValue(item.staffScore)}</SmallScore></Td>
// // //                         <Td><SmallScore $isDarkMode={isDarkMode}>{ScoreValue(item.supervisorScore)}</SmallScore></Td>
// // //                         <Td>
// // //                           <Select value={item.adminScore ?? ""} onChange={(e) => handleAdminScore(index, e.target.value)} $isDarkMode={isDarkMode}>
// // //                             {ratingScale.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
// // //                           </Select>
// // //                         </Td>
// // //                         <Td>
// // //                           <Textarea 
// // //                             value={item.adminComments || ""}
// // //                             onChange={(e) => handleAdminComment(index, e.target.value)}
// // //                             placeholder="Add administrative feedback..."
// // //                             $isDarkMode={isDarkMode}
// // //                           />
// // //                         </Td>
// // //                       </tr>
// // //                     ))}
// // //                   </tbody>
// // //                 </Table>
// // //               </TableWrapper>

// // //               <CalcGrid>
// // //                 <CalcBox variant="staff" $isDarkMode={isDarkMode}>
// // //                   <CalcTitle variant="staff" $isDarkMode={isDarkMode}>Staff Self-Assessment</CalcTitle>
// // //                   <CalcLine variant="staff" $isDarkMode={isDarkMode}>Items Scored: {scores.staff.completed}</CalcLine>
// // //                   <CalcLine variant="staff" $isDarkMode={isDarkMode}>Average: {scores.staff.rawAvg}</CalcLine>
// // //                   <CalcLine variant="staff" $isDarkMode={isDarkMode} strong>TOTAL: {scores.staff.total} / 10</CalcLine>
// // //                 </CalcBox>
                
// // //                 <CalcBox variant="supervisor" $isDarkMode={isDarkMode}>
// // //                   <CalcTitle variant="supervisor" $isDarkMode={isDarkMode}>Supervisor Assessment</CalcTitle>
// // //                   <CalcLine variant="supervisor" $isDarkMode={isDarkMode}>Items Scored: {scores.supervisor.completed}</CalcLine>
// // //                   <CalcLine variant="supervisor" $isDarkMode={isDarkMode}>Average: {scores.supervisor.rawAvg}</CalcLine>
// // //                   <CalcLine variant="supervisor" $isDarkMode={isDarkMode} strong>TOTAL: {scores.supervisor.total} / 10</CalcLine>
// // //                 </CalcBox>
                
// // //                 <CalcBox variant="admin" $isDarkMode={isDarkMode}>
// // //                   <CalcTitle variant="admin" $isDarkMode={isDarkMode}>Admin Final Assessment</CalcTitle>
// // //                   <CalcLine variant="admin" $isDarkMode={isDarkMode}>Items Scored: {scores.admin.completed}</CalcLine>
// // //                   <CalcLine variant="admin" $isDarkMode={isDarkMode}>Average: {scores.admin.rawAvg}</CalcLine>
// // //                   <CalcLine variant="admin" $isDarkMode={isDarkMode} strong>TOTAL: {scores.admin.total} / 10</CalcLine>
// // //                 </CalcBox>
// // //               </CalcGrid>

// // //               <ActionWrap>
// // //                 <SubmitButton onClick={handleSave} disabled={saving || savedRecently} success={savedRecently}>
// // //                   {saving ? "Processing..." : savedRecently ? "Oversight Logged Successfully! ✓" : "Commit Admin Evaluation"}
// // //                 </SubmitButton>
// // //               </ActionWrap>
// // //             </>
// // //           )}
// // //         </SectionCard>
// // //       </Main>
// // //       <Footer />
// // //     </Container>
// // //   );
// // // };

// // // export default AdminAppraisalForm;



// // import React, { useEffect, useMemo, useState } from "react";
// // import styled from "styled-components";
// // import { useParams, useNavigate } from "react-router-dom";
// // import { FaArrowLeft, FaShieldAlt } from "react-icons/fa";
// // import NavBarSuper from "./NavBarSuper";
// // import DashboardHeader from "./DashboardHeader";
// // import Footer from "./Footer";
// // import api from "../api";
// // import { useTheme } from "../App";

// // /* ================= HELPERS ================= */
// // const getCurrentMonthName = () => {
// //   const date = new Date();
// //   return date.toLocaleString("default", { month: "long", year: "numeric" });
// // };

// // const generateMonthOptions = () => {
// //   const months = [];
// //   const date = new Date();
// //   date.setMonth(date.getMonth() - 3); 
// //   for (let i = 0; i < 12; i++) {
// //     months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
// //     date.setMonth(date.getMonth() + 1);
// //   }
// //   return months;
// // };

// // const parseScoreValue = (value) => {
// //   if (value === "N/A" || value === "" || value == null) return null;
// //   const num = Number(value);
// //   return Number.isNaN(num) ? null : num;
// // };

// // const ScoreValue = (value) => {
// //   if (value === "N/A" || value === "" || value == null) return null;
// //   const num = Number(value);
// //   return Number.isNaN(num) ? null : num;
// // };

// // const formatScore = (value) => Number(value || 0).toFixed(1);

// // const complianceItems = [
// //   { attribute: "Feedback", description: "Measures the progress and status of work with the use of relevant tools. Gives quality and consistent information on assigned tasks." },
// //   { attribute: "Responsiveness to official communication", description: "Is reachable and responsive on Kingschat and official communication platforms." },
// //   { attribute: "Care and Maintenance of office space and equipment", description: "Consistently maintains a clean, tidy and orderly office space. Takes good care of all equipment, keeping them in optimal working condition." },
// //   { attribute: "Ministry Programs", description: "Participates in Ministry Global Programs such as Your Loveworld, GDOP, etc." },
// //   { attribute: "Church Services and Meetings", description: "Consistently and punctually at Sunday and Wednesday Church Services, Prayer Services." },
// //   { attribute: "Monthly Goals", description: "Promptly submits monthly goals before 1st 12.00am of each month." },
// //   { attribute: "Weekly Goals", description: "Promptly submits weekly goals on or before Saturday 11.59pm." },
// //   { attribute: "Weekly Reporting", description: "Promptly submits all weekly reports on or before Saturday 11:59pm." },
// //   { attribute: "Performance Reporting", description: "Promptly submits performance appraisal form on or before 1st of each month." },
// //   { attribute: "Online publicity and awareness creation", description: "Consistently publicizes, promotes and creates awareness of departmental products and activities online and physically as required. (Free type)" },
// //   { attribute: "Staff Trainings", description: "Consistently and punctually at Staff Training Programs and products, STDL, other Ministry trainings for staff." },
// //   { attribute: "Office Attendance", description: "Consistently and punctually at the office." },
// //   { attribute: "Office Prayer Meetings", description: "Consistently and punctually at Staff Office Prayer Meetings (onsite and online)." },
// //   { attribute: "Staff Chapel & Care Group Meetings", description: "Consistently and punctually at Staff Chapel Services & Staff Care Group Meetings."},
// //   { attribute: "Uniforms", description: "Wears clean, proper and appropriate uniforms." },
// // ];

// // const standardRatingScale = [
// //   { value: "", label: "Select..." },
// //   { value: "N/A", label: "N/A" },
// //   { value: "0", label: "0" },
// //   { value: "1", label: "1" },
// //   { value: "2", label: "2" },
// //   { value: "3", label: "3" },
// //   { value: "4", label: "4" },
// //   { value: "5", label: "5" },
// //   { value: "6", label: "6" },
// //   { value: "7", label: "7" },
// //   { value: "8", label: "8" },
// //   { value: "9", label: "9" },
// //   { value: "10", label: "10" }
// // ];

// // const weeklyRatingScale = [
// //   { value: "", label: "-" },
// //   { value: "0", label: "0" },
// //   { value: "1", label: "1" },
// //   { value: "2", label: "2" },
// //   { value: "3", label: "3" },
// //   { value: "4", label: "4" },
// //   { value: "5", label: "5" }
// // ];

// // /* ================= PAGE LAYOUT & THEME VARIABLES ================= */
// // const Container = styled.div`
// //   ${'' /* --sidebar-expanded: 260px;
// //   --sidebar-collapsed: 90px; */}
  
// //   --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
// //   --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.96)'};
// //   --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
// //   --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
// //   --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
// //   --input-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'};
// //   --table-header-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#f0fdf4'};
// //   --table-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#bbf7d0'};

// //   min-height: 100vh;
// //   background: var(--page-bg);
// //   color: var(--text-main);
// //   margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
// //   transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;

// //   @media (max-width: 1023px) { margin-left: 0; }
// // `;

// // const Main = styled.main`
// //   width: 100%; /* Full width */
// //   padding: 94px 24px 80px; 
// //   box-sizing: border-box;
// //   @media (max-width: 1023px) { padding: 86px 16px 80px; }
// // `;

// // /* ================= COMPONENTS ================= */
// // const BackButton = styled.button` 
// //   display: inline-flex; align-items: center; gap: 8px; background: none; border: none;
// //   color: #16a34a; font-weight: 800; font-size: 1rem; cursor: pointer; transition: transform 0.2s ease; padding: 0; margin-bottom: 24px;
// //   &:hover { transform: translateX(-4px); text-decoration: underline; }
// // `;

// // const SectionCard = styled.section`
// //   background: var(--card-bg); border: 1px solid var(--border); border-radius: 28px; padding: 32px; box-shadow: 0 12px 30px rgba(0,0,0,0.05); margin-bottom: 32px;
// //   transition: background 0.3s ease, border 0.3s ease;
// //   @media (max-width: 768px) { padding: 20px; border-radius: 22px; }
// // `;

// // const HeaderRow = styled.div`
// //   display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 16px; margin-bottom: 24px;
// // `;

// // const SectionTitle = styled.h2` margin: 0; font-size: clamp(1.2rem, 1rem + 0.6vw, 1.6rem); font-weight: 900; color: var(--text-main); display: flex; align-items: center; gap: 12px; `;

// // const GlobalMonthSelect = styled.select`
// //   padding: 8px 16px; border-radius: 12px; border: 2px solid ${({ $isDarkMode }) => $isDarkMode ? '#22c55e' : '#86efac'}; 
// //   font-size: 1.1rem; font-weight: 800; color: #16a34a; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.1)' : '#f0fdf4'}; 
// //   outline: none; cursor: pointer; transition: all 0.2s;
// //   &:focus { border-color: #16a34a; box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.1); }
// // `;

// // const Subtitle = styled.p` color: var(--text-soft); margin: 0; font-size: 0.95rem; line-height: 1.6; max-width: 800px; `;

// // const StaffInfoBox = styled.div`
// //   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.05)' : '#eff6ff'};
// //   border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#1e3a8a' : '#bfdbfe'};
// //   padding: 16px 20px; border-radius: 16px; margin-bottom: 24px; display: inline-flex; align-items: center; gap: 16px; flex-wrap: wrap;
// // `;

// // const StaffName = styled.div` font-size: 1.1rem; font-weight: 800; color: ${({ $isDarkMode }) => $isDarkMode ? '#93c5fd' : '#1e40af'}; `;
// // const StaffRole = styled.div` font-size: 0.9rem; font-weight: 600; color: var(--text-soft); background: var(--card-bg); padding: 4px 10px; border-radius: 999px; border: 1px solid var(--border); `;

// // /* ================= TABLE STYLES ================= */
// // const TableWrapper = styled.div`
// //   width: 100%; overflow-x: auto; border-radius: 14px; border: 1px solid var(--table-border);
// // `;

// // const Table = styled.table`
// //   width: 100%; border-collapse: separate; border-spacing: 0; background: transparent; table-layout: fixed; min-width: 1100px;
// // `;

// // const Th = styled.th`
// //   background: var(--table-header-bg); padding: 14px 10px; text-align: left; font-size: 12px; font-weight: 800; 
// //   color: ${({ $isDarkMode }) => $isDarkMode ? '#86efac' : '#15803d'}; border-bottom: 1px solid var(--table-border); vertical-align: middle;
// //   &:first-child { border-top-left-radius: 14px; } &:last-child { border-top-right-radius: 14px; }
// // `;

// // const Td = styled.td`
// //   padding: 14px 10px; border-bottom: 1px solid var(--table-border); vertical-align: top;
// // `;

// // const Serial = styled.div`
// //   width: 28px; height: 28px; display: grid; place-items: center; border-radius: 50%; 
// //   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.15)' : '#f0fdf4'}; 
// //   color: ${({ $isDarkMode }) => $isDarkMode ? '#86efac' : '#15803d'}; font-weight: 800; font-size: 0.85rem;
// // `;

// // const AttributeBox = styled.div`
// //   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.05)' : '#f0fdf4'}; 
// //   padding: 8px 12px; border-left: 4px solid #22c55e; border-radius: 8px; font-weight: 700; 
// //   color: ${({ $isDarkMode }) => $isDarkMode ? '#bbf7d0' : '#14532d'}; font-size: 0.85rem; word-wrap: break-word;
// // `;

// // const DisabledInput = styled.div`
// //   min-height: 32px; border: 1px solid var(--input-border); background: ${({ $isDarkMode }) => $isDarkMode ? 'var(--input-bg)' : '#f8fafc'};
// //   color: var(--text-soft); border-radius: 6px; padding: 8px; line-height: 1.4; white-space: pre-wrap; font-size: 13px;
// // `;

// // const SmallScore = styled.div`
// //   width: 36px; height: 36px; display: inline-flex; align-items: center; justify-content: center; border-radius: 6px;
// //   border: 1px solid var(--input-border); background: ${({ $isDarkMode }) => $isDarkMode ? 'var(--input-bg)' : '#f8fafc'}; 
// //   font-weight: 800; color: var(--text-soft); font-size: 13px;
// // `;

// // const Select = styled.select`
// //   width: 100%; padding: 10px; border-radius: 8px; border: 2px solid ${({ $isDarkMode }) => $isDarkMode ? '#14532d' : '#86efac'}; 
// //   font-size: 13px; font-weight: 700; color: var(--text-main); background: var(--input-bg); outline: none; transition: all 0.2s;
// //   &:focus { border-color: #22c55e; box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15); }
// // `;

// // const Textarea = styled.textarea`
// //   width: 100%; min-height: 60px; padding: 10px; border: 1px solid var(--input-border); border-radius: 8px; resize: vertical; 
// //   font-size: 13px; line-height: 1.4; background: var(--input-bg); color: var(--text-main); outline: none; box-sizing: border-box;
// //   &:focus { border-color: #22c55e; box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15); }
// // `;

// // /* 🔥 NEW: Weekly Input Grid 🔥 */
// // const WeeklyInputGrid = styled.div`
// //   display: grid;
// //   grid-template-columns: repeat(4, 1fr);
// //   gap: 4px;
// // `;

// // const WeeklyInputLabel = styled.div`
// //   font-size: 9px;
// //   color: var(--text-soft);
// //   text-align: center;
// //   font-weight: 700;
// //   text-transform: uppercase;
// // `;

// // /* ================= SCORE CALCULATION BOXES ================= */
// // const CalcGrid = styled.div` display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-top: 24px; @media (max-width: 900px) { grid-template-columns: 1fr; } `;

// // const CalcBox = styled.div`
// //   padding: 24px; border-radius: 20px; border-left: 5px solid; line-height: 1.75; box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
// //   background: ${({ variant, $isDarkMode }) => 
// //     variant === "admin" ? ($isDarkMode ? 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)' : "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)") :
// //     variant === "supervisor" ? ($isDarkMode ? 'linear-gradient(135deg, #064e3b 0%, #14532d 100%)' : "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)") :
// //     ($isDarkMode ? 'linear-gradient(135deg, #1e293b 0%, #334155 100%)' : "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)")
// //   };
// //   border-left-color: ${({ variant }) => variant === "admin" ? "#8b5cf6" : variant === "supervisor" ? "#16a34a" : "#64748b"};
// // `;

// // const CalcTitle = styled.div`
// //   font-size: 1.05rem; font-weight: 900; margin-bottom: 8px;
// //   color: ${({ variant, $isDarkMode }) => variant === "admin" ? ($isDarkMode ? "#c4b5fd" : "#4c1d95") : variant === "supervisor" ? ($isDarkMode ? "#4ade80" : "#16a34a") : ($isDarkMode ? "#cbd5e1" : "#475569")};
// // `;

// // const CalcLine = styled.div`
// //   font-size: 0.95rem; font-weight: ${({ strong }) => strong ? 800 : 500};
// //   color: ${({ variant, $isDarkMode }) => variant === "admin" ? ($isDarkMode ? "#ddd6fe" : "#5b21b6") : variant === "supervisor" ? ($isDarkMode ? "#86efac" : "#15803d") : ($isDarkMode ? "#f8fafc" : "#334155")};
// // `;

// // /* ================= ACTIONS & STATES ================= */
// // const ActionWrap = styled.div` display: flex; width: 100%; margin-top: 32px; `;

// // const SubmitButton = styled.button`
// //   appearance: none; border: none; outline: none; border-radius: 16px; padding: 18px 36px; width: 100%;
// //   background: ${({ disabled, success }) => disabled && !success ? "linear-gradient(135deg, #94a3b8, #cbd5e1)" : "linear-gradient(135deg, #16a34a, #22c55e)"}; 
// //   color: white; font-size: 1.1rem; font-weight: 800; cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
// //   box-shadow: ${({ disabled, success }) => disabled && !success ? "none" : "0 14px 28px rgba(34, 197, 94, 0.25)"}; transition: all 0.2s ease;
// //   &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 18px 30px rgba(34, 197, 94, 0.3); }
// // `;

// // const CenterState = styled.div` min-height: 50vh; display: grid; place-items: center; `;
// // const StateCard = styled.div` width: min(460px, 100%); background: var(--card-bg); border: 1px solid var(--border); border-radius: 24px; padding: 32px; text-align: center; box-shadow: var(--shadow-md); `;
// // const Spinner = styled.div` width: 46px; height: 46px; margin: 0 auto 18px; border-radius: 50%; border: 4px solid var(--border); border-top-color: #16a34a; animation: spin 0.8s linear infinite; @keyframes spin { to { transform: rotate(360deg); } } `;
// // const StateTitle = styled.h3` margin: 0 0 8px; font-size: 1.2rem; color: var(--text-main); font-weight: 800; `;
// // const StateText = styled.p` margin: 10px 0 0; color: var(--text-soft); line-height: 1.6; `;

// // /* ================= COMPONENT ================= */
// // const AdminAppraisalForm = ({ user, collapsed, setCollapsed }) => {
// //   const { isDarkMode } = useTheme();
// //   const { userId } = useParams(); 
// //   const navigate = useNavigate();

// //   const [loading, setLoading] = useState(true);
// //   const [saving, setSaving] = useState(false);
// //   const [savedRecently, setSavedRecently] = useState(false);
  
// //   const [staffInfo, setStaffInfo] = useState(null);
// //   const [appraisalId, setAppraisalId] = useState(null);
// //   const [section4Data, setSection4Data] = useState([]);
  
// //   const availableMonths = useMemo(() => generateMonthOptions(), []);
  
// //   const [selectedMonth, setSelectedMonth] = useState(
// //     localStorage.getItem("adminViewMonth") || getCurrentMonthName()
// //   );

// //   useEffect(() => {
// //     localStorage.setItem("adminViewMonth", selectedMonth);
// //   }, [selectedMonth]);

// //   useEffect(() => {
// //     const fetchAppraisal = async () => {
// //       if (!userId) return;
// //       setLoading(true);
// //       try {
// //         const res = await api.get(`/appraisal/admin/user/${userId}/${selectedMonth}`);
        
// //         if (res.data.success && res.data.data) {
// //           const appraisal = res.data.data;
// //           setAppraisalId(appraisal._id);
// //           setStaffInfo(appraisal.userId || appraisal.user || appraisal.userDetails || {});
          
// //           const mergedData = complianceItems.map((defaultItem, index) => {
// //             const existing = (appraisal.section4 || []).find(dbItem => dbItem.attribute === defaultItem.attribute);
            
// //             let weeklyScores = existing?.weeklyScores || { week1: "", week2: "", week3: "", week4: "" };

// //             return {
// //               ...defaultItem,
// //               staffScore: existing?.staffScore || "",
// //               supervisorScore: existing?.supervisorScore || "",
// //               supervisorComments: existing?.supervisorComments || "",
// //               adminComments: existing?.adminComments || "",
// //               weeklyScores: index >= 11 && index <= 14 ? weeklyScores : null
// //             };
// //           });
// //           setSection4Data(mergedData);
// //         } else {
// //           setAppraisalId(null);
// //           setStaffInfo(null);
// //           setSection4Data(complianceItems.map((item, index) => ({ 
// //             ...item, 
// //             staffScore: "", 
// //             supervisorScore: "", 
// //             adminComments: "",
// //             weeklyScores: index >= 11 && index <= 14 ? { week1: "", week2: "", week3: "", week4: "" } : null
// //           })));
// //         }
// //       } catch (err) {
// //         console.error("Error fetching appraisal:", err);
// //         setAppraisalId(null);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchAppraisal();
// //   }, [userId, selectedMonth]);

// //   const handleAdminScore = (index, value) => {
// //     setSection4Data(prev => prev.map((item, i) => i === index ? { ...item, supervisorScore: value } : item));
// //   };

// //   const handleWeeklyScore = (itemIndex, weekKey, value) => {
// //     setSection4Data(prev => {
// //       const nextData = [...prev];
// //       const item = { ...nextData[itemIndex] };
// //       const newWeeklyScores = { ...item.weeklyScores, [weekKey]: value };
      
// //       const scores = Object.values(newWeeklyScores).map(s => parseScoreValue(s)).filter(s => s !== null);
// //       let avgScore = "";
// //       if (scores.length > 0) {
// //         const sum = scores.reduce((a, b) => a + b, 0);
// //         avgScore = (sum / scores.length).toFixed(1); 
// //       }

// //       item.weeklyScores = newWeeklyScores;
// //       item.supervisorScore = avgScore; 
// //       nextData[itemIndex] = item;
// //       return nextData;
// //     });
// //   };

// //   const handleAdminComment = (index, value) => {
// //     setSection4Data(prev => prev.map((item, i) => i === index ? { ...item, adminComments: value } : item));
// //   };

// //   const calculateScores = () => {
// //     const calcGroup = (scoreKey, maxScore = 10, bonusIndex = 15) => {
// //       const validScores = section4Data.filter((item, i) => i < 15).map(item => parseScoreValue(item[scoreKey])).filter(s => s !== null);
// //       const bonusScore = parseScoreValue(section4Data[bonusIndex]?.[scoreKey]) || 0;
      
// //       if (validScores.length === 0) return { total: 0, completed: 0, rawAvg: 0 };
      
// //       const sum = validScores.reduce((acc, val) => acc + val, 0) + bonusScore;
// //       const avg = sum / validScores.length;
// //       let total = (avg / 5) * maxScore;
// //       total = Math.min(total, maxScore); 
      
// //       return { total: total.toFixed(1), completed: validScores.length + (bonusScore > 0 ? 1 : 0), rawAvg: avg.toFixed(2) };
// //     };

// //     return {
// //       staff: calcGroup('staffScore'),
// //       supervisor: calcGroup('supervisorScore'), 
// //       admin: calcGroup('supervisorScore') 
// //     };
// //   };

// //   const scores = calculateScores();

// //   const handleSave = async () => {
// //     if (!appraisalId) return alert("No appraisal document found to update for this month.");
    
// //     setSaving(true);
// //     try {
// //       const payload = {
// //         section4: section4Data,
// //         summary: {
// //           section4: parseFloat(scores.admin.total) || 0,
// //           hodOverallComments: "" 
// //         }
// //       };

// //       await api.put(`/appraisal/admin-score/${appraisalId}`, payload);
      
// //       setSavedRecently(true);
// //       setTimeout(() => setSavedRecently(false), 3000);
// //     } catch (error) {
// //       console.error(error);
// //       alert("Failed to save Admin assessment.");
// //     } finally {
// //       setSaving(false);
// //     }
// //   };

// //   if (loading) {
// //     return (
// //       <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
// //         <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
// //         <Main>
// //           <CenterState>
// //             <StateCard>
// //               <Spinner />
// //               <StateTitle>Accessing Records...</StateTitle>
// //               <StateText>Retrieving compliance logs for {selectedMonth}.</StateText>
// //             </StateCard>
// //           </CenterState>
// //         </Main>
// //       </Container>
// //     );
// //   }

// //   return (
// //     <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
// //       <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
// //       <DashboardHeader user={user} collapsed={collapsed} />

// //       <Main>
// //         <BackButton onClick={() => navigate('/admin/dashboard')}>
// //           <FaArrowLeft /> Back to Directory
// //         </BackButton>

// //         <SectionCard>
// //           <HeaderRow>
// //             <SectionTitle><FaShieldAlt style={{color: '#16a34a'}}/> Compliance Oversight</SectionTitle>
// //             <GlobalMonthSelect $isDarkMode={isDarkMode} value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
// //               {availableMonths.map(m => <option key={m} value={m}>{m}</option>)}
// //             </GlobalMonthSelect>
// //           </HeaderRow>
          
// //           <Subtitle>Review the compliance adherence scores for this specific staff member. Items 1-9 are read-only. You may override or finalize the assessment for items 10-15 using the Supervisor Score column.</Subtitle>

// //           {staffInfo?.firstName && (
// //             <StaffInfoBox $isDarkMode={isDarkMode} style={{ marginTop: '20px' }}>
// //               <StaffName $isDarkMode={isDarkMode}>{staffInfo.firstName} {staffInfo.surname}</StaffName>
// //               <StaffRole>{staffInfo.unit || 'No Unit Assigned'}</StaffRole>
// //             </StaffInfoBox>
// //           )}

// //           {!appraisalId ? (
// //             <CenterState style={{ minHeight: '30vh' }}>
// //               <StateTitle>No Record Found</StateTitle>
// //               <StateText>This user has not initiated an appraisal draft for {selectedMonth}.</StateText>
// //             </CenterState>
// //           ) : (
// //             <>
// //               <TableWrapper>
// //                 <Table>
// //                   <colgroup>
// //                     <col style={{ width: "4%" }} />
// //                     <col style={{ width: "16%" }} />
// //                     <col style={{ width: "30%" }} />
// //                     <col style={{ width: "6%" }} />
// //                     <col style={{ width: "16%" }} /> 
// //                     <col style={{ width: "28%" }} />
// //                   </colgroup>
// //                   <thead>
// //                     <tr>
// //                       <Th $isDarkMode={isDarkMode}>S/N</Th>
// //                       <Th $isDarkMode={isDarkMode}>Protocol</Th>
// //                       <Th $isDarkMode={isDarkMode}>Description</Th>
// //                       <Th $isDarkMode={isDarkMode}>Staff<br/>Score</Th>
// //                       <Th $isDarkMode={isDarkMode}>Supervisor's Score</Th>
// //                       <Th $isDarkMode={isDarkMode}>Admin Comments</Th>
// //                     </tr>
// //                   </thead>
// //                   <tbody>
// //                     {section4Data.map((item, index) => {
// //                       const isWeeklyScoreItem = index >= 11 && index <= 14; // Items 12-15
// //                       const isEditableByAdmin = index >= 9 && index <= 14; // Items 10-15

// //                       return (
// //                         <tr key={index}>
// //                           <Td><Serial $isDarkMode={isDarkMode}>{index + 1}</Serial></Td>
// //                           <Td><AttributeBox $isDarkMode={isDarkMode}>{item.attribute}</AttributeBox></Td>
// //                           <Td><DisabledInput $isDarkMode={isDarkMode}>{item.description}</DisabledInput></Td>
// //                           <Td><SmallScore $isDarkMode={isDarkMode}>{ScoreValue(item.staffScore)}</SmallScore></Td>
                          
// //                           <Td>
// //                             {/* 🔥 Check Edit Permissions 🔥 */}
// //                             {isEditableByAdmin ? (
// //                               /* Admin Can Edit Items 10-15 */
// //                               isWeeklyScoreItem ? (
// //                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
// //                                   <WeeklyInputGrid>
// //                                     <div>
// //                                       <WeeklyInputLabel>Wk 1</WeeklyInputLabel>
// //                                       <Select value={item.weeklyScores?.week1 ?? ""} onChange={(e) => handleWeeklyScore(index, 'week1', e.target.value)} $isDarkMode={isDarkMode}>
// //                                         {weeklyRatingScale.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
// //                                       </Select>
// //                                     </div>
// //                                     <div>
// //                                       <WeeklyInputLabel>Wk 2</WeeklyInputLabel>
// //                                       <Select value={item.weeklyScores?.week2 ?? ""} onChange={(e) => handleWeeklyScore(index, 'week2', e.target.value)} $isDarkMode={isDarkMode}>
// //                                         {weeklyRatingScale.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
// //                                       </Select>
// //                                     </div>
// //                                     <div>
// //                                       <WeeklyInputLabel>Wk 3</WeeklyInputLabel>
// //                                       <Select value={item.weeklyScores?.week3 ?? ""} onChange={(e) => handleWeeklyScore(index, 'week3', e.target.value)} $isDarkMode={isDarkMode}>
// //                                         {weeklyRatingScale.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
// //                                       </Select>
// //                                     </div>
// //                                     <div>
// //                                       <WeeklyInputLabel>Wk 4</WeeklyInputLabel>
// //                                       <Select value={item.weeklyScores?.week4 ?? ""} onChange={(e) => handleWeeklyScore(index, 'week4', e.target.value)} $isDarkMode={isDarkMode}>
// //                                         {weeklyRatingScale.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
// //                                       </Select>
// //                                     </div>
// //                                   </WeeklyInputGrid>
// //                                   <div style={{ fontSize: '11px', color: 'var(--text-soft)', textAlign: 'right' }}>
// //                                     Average Score: <strong style={{ color: 'var(--text-main)' }}>{item.supervisorScore || "0"}</strong>
// //                                   </div>
// //                                 </div>
// //                               ) : (
// //                                 /* Standard Input for Items 10-11 */
// //                                 <Select value={item.supervisorScore ?? ""} onChange={(e) => handleAdminScore(index, e.target.value)} $isDarkMode={isDarkMode}>
// //                                   {standardRatingScale.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
// //                                 </Select>
// //                               )
// //                             ) : (
// //                               /* Admin Cannot Edit Items 1-9 */
// //                               <SmallScore muted $isDarkMode={isDarkMode}>{ScoreValue(item.supervisorScore)}</SmallScore>
// //                             )}
// //                           </Td>

// //                           <Td>
// //                             {isEditableByAdmin ? (
// //                               <Textarea 
// //                                 value={item.adminComments || ""}
// //                                 onChange={(e) => handleAdminComment(index, e.target.value)}
// //                                 placeholder="Add administrative feedback..."
// //                                 $isDarkMode={isDarkMode}
// //                               />
// //                             ) : (
// //                               <DisabledInput $isDarkMode={isDarkMode}>
// //                                 {item.adminComments || "No administrative feedback."}
// //                               </DisabledInput>
// //                             )}
// //                           </Td>
// //                         </tr>
// //                       )
// //                     })}
// //                   </tbody>
// //                 </Table>
// //               </TableWrapper>

// //               <CalcGrid>
// //                 <CalcBox variant="staff" $isDarkMode={isDarkMode}>
// //                   <CalcTitle variant="staff" $isDarkMode={isDarkMode}>Staff Self-Assessment</CalcTitle>
// //                   <CalcLine variant="staff" $isDarkMode={isDarkMode}>Items Scored: {scores.staff.completed}</CalcLine>
// //                   <CalcLine variant="staff" $isDarkMode={isDarkMode}>Average: {scores.staff.rawAvg}</CalcLine>
// //                   <CalcLine variant="staff" $isDarkMode={isDarkMode} strong>TOTAL: {scores.staff.total} / 10</CalcLine>
// //                 </CalcBox>
                
// //                 <CalcBox variant="supervisor" $isDarkMode={isDarkMode}>
// //                   <CalcTitle variant="supervisor" $isDarkMode={isDarkMode}>Supervisor Assessment</CalcTitle>
// //                   <CalcLine variant="supervisor" $isDarkMode={isDarkMode}>Items Scored: {scores.supervisor.completed}</CalcLine>
// //                   <CalcLine variant="supervisor" $isDarkMode={isDarkMode}>Average: {scores.supervisor.rawAvg}</CalcLine>
// //                   <CalcLine variant="supervisor" $isDarkMode={isDarkMode} strong>TOTAL: {scores.supervisor.total} / 10</CalcLine>
// //                 </CalcBox>
                
// //                 <CalcBox variant="admin" $isDarkMode={isDarkMode}>
// //                   <CalcTitle variant="admin" $isDarkMode={isDarkMode}>Admin Final Assessment</CalcTitle>
// //                   <CalcLine variant="admin" $isDarkMode={isDarkMode}>Items Scored: {scores.admin.completed}</CalcLine>
// //                   <CalcLine variant="admin" $isDarkMode={isDarkMode}>Average: {scores.admin.rawAvg}</CalcLine>
// //                   <CalcLine variant="admin" $isDarkMode={isDarkMode} strong>TOTAL: {scores.admin.total} / 10</CalcLine>
// //                 </CalcBox>
// //               </CalcGrid>

// //               <ActionWrap>
// //                 <SubmitButton onClick={handleSave} disabled={saving || savedRecently} success={savedRecently}>
// //                   {saving ? "Processing..." : savedRecently ? "Oversight Logged Successfully! ✓" : "Commit Admin Evaluation"}
// //                 </SubmitButton>
// //               </ActionWrap>
// //             </>
// //           )}
// //         </SectionCard>
// //       </Main>
// //       <Footer />
// //     </Container>
// //   );
// // };

// // export default AdminAppraisalForm;



// import React, { useEffect, useMemo, useState } from "react";
// import styled from "styled-components";
// import { useParams, useNavigate } from "react-router-dom";
// import { FaArrowLeft, FaShieldAlt } from "react-icons/fa";
// import NavBarSuper from "./NavBarSuper";
// import DashboardHeader from "./DashboardHeader";
// import Footer from "./Footer";
// import api from "../api";
// import { useTheme } from "../App";

// /* ================= HELPERS ================= */
// const getCurrentMonthName = () => {
//   const date = new Date();
//   return date.toLocaleString("default", { month: "long", year: "numeric" });
// };

// const generateMonthOptions = () => {
//   const months = [];
//   const date = new Date();
//   date.setMonth(date.getMonth() - 3); 
//   for (let i = 0; i < 12; i++) {
//     months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
//     date.setMonth(date.getMonth() + 1);
//   }
//   return months;
// };

// // 🔥 NEW: Dynamically generate week labels for the selected month 🔥
// const generateWeekLabels = (periodString) => {
//   const defaultLabels = ["Wk 1", "Wk 2", "Wk 3", "Wk 4", "Wk 5"];
//   if (!periodString) return defaultLabels;
  
//   const d = new Date(periodString);
//   if (isNaN(d.getTime())) return defaultLabels;
  
//   const y = d.getFullYear();
//   const m = d.getMonth();
//   const lastDay = new Date(y, m + 1, 0); // Gets the last day of the current month
  
//   const labels = ["Wk 1", "Wk 2", "Wk 3", "Wk 4"];
  
//   // If the last day is not a Saturday (6), the week spills into the next month
//   if (lastDay.getDay() !== 6) { 
//     const nextMonth = new Date(y, m + 1, 1).toLocaleString('default', { month: 'short' });
//     labels.push(`Wk 5 / ${nextMonth} Wk 1`);
//   } else {
//     labels.push("Wk 5");
//   }
  
//   return labels;
// };

// const parseScoreValue = (value) => {
//   if (value === "N/A" || value === "" || value == null) return null;
//   const num = Number(value);
//   return Number.isNaN(num) ? null : num;
// };

// const ScoreValue = (value) => {
//   if (value === "N/A" || value === "" || value == null) return null;
//   const num = Number(value);
//   return Number.isNaN(num) ? null : num;
// };

// const formatScore = (value) => Number(value || 0).toFixed(1);

// const complianceItems = [
//   { attribute: "Feedback", description: "Measures the progress and status of work with the use of relevant tools. Gives quality and consistent information on assigned tasks." },
//   { attribute: "Responsiveness to official communication", description: "Is reachable and responsive on Kingschat and official communication platforms." },
//   { attribute: "Care and Maintenance of office space and equipment", description: "Consistently maintains a clean, tidy and orderly office space. Takes good care of all equipment, keeping them in optimal working condition." },
//   { attribute: "Ministry Programs", description: "Participates in Ministry Global Programs such as Your Loveworld, GDOP, etc." },
//   { attribute: "Church Services and Meetings", description: "Consistently and punctually at Sunday and Wednesday Church Services, Prayer Services." },
//   { attribute: "Monthly Goals", description: "Promptly submits monthly goals before 1st 12.00am of each month." },
//   { attribute: "Weekly Goals", description: "Promptly submits weekly goals on or before Saturday 11.59pm." },
//   { attribute: "Weekly Reporting", description: "Promptly submits all weekly reports on or before Saturday 11:59pm." },
//   { attribute: "Performance Reporting", description: "Promptly submits performance appraisal form on or before 1st of each month." },
//   { attribute: "Online publicity and awareness creation", description: "Consistently publicizes, promotes and creates awareness of departmental products and activities online and physically as required. (Free type)" },
//   { attribute: "Staff Trainings", description: "Consistently and punctually at Staff Training Programs and products, STDL, other Ministry trainings for staff." },
//   { attribute: "Office Attendance", description: "Consistently and punctually at the office." },
//   { attribute: "Office Prayer Meetings", description: "Consistently and punctually at Staff Office Prayer Meetings (onsite and online)." },
//   { attribute: "Staff Chapel & Care Group Meetings", description: "Consistently and punctually at Staff Chapel Services & Staff Care Group Meetings."},
//   { attribute: "Uniforms", description: "Wears clean, proper and appropriate uniforms." },
// ];

// const standardRatingScale = [
//   { value: "", label: "Select..." },
//   { value: "N/A", label: "N/A" },
//   { value: "0", label: "0" },
//   { value: "1", label: "1" },
//   { value: "2", label: "2" },
//   { value: "3", label: "3" },
//   { value: "4", label: "4" },
//   { value: "5", label: "5" },
//   { value: "6", label: "6" },
//   { value: "7", label: "7" },
//   { value: "8", label: "8" },
//   { value: "9", label: "9" },
//   { value: "10", label: "10" }
// ];

// const weeklyRatingScale = [
//   { value: "", label: "-" },
//   { value: "0", label: "0" },
//   { value: "1", label: "1" },
//   { value: "2", label: "2" },
//   { value: "3", label: "3" },
//   { value: "4", label: "4" },
//   { value: "5", label: "5" }
// ];
// //JUN
// /* ================= PAGE LAYOUT & THEME VARIABLES ================= */
// const Container = styled.div`
//   ${'' /* --sidebar-expanded: 260px;
//   --sidebar-collapsed: 90px; */}
  
//   --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
//   --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.96)'};
//   --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
//   --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
//   --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
//   --input-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'};
//   --table-header-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#f0fdf4'};
//   --table-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#bbf7d0'};

//   min-height: 100vh;
//   background: var(--page-bg);
//   color: var(--text-main);
//   margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
//   transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;

//   @media (max-width: 1023px) { margin-left: 0; }
// `;

// const Main = styled.main`
//   width: 100%; 
//   padding: 94px 24px 80px; 
//   box-sizing: border-box;
//   @media (max-width: 1023px) { padding: 86px 16px 80px; }
// `;

// /* ================= COMPONENTS ================= */
// const BackButton = styled.button` 
//   display: inline-flex; align-items: center; gap: 8px; background: none; border: none;
//   color: #16a34a; font-weight: 800; font-size: 1rem; cursor: pointer; transition: transform 0.2s ease; padding: 0; margin-bottom: 24px;
//   &:hover { transform: translateX(-4px); text-decoration: underline; }
// `;

// const SectionCard = styled.section`
//   background: var(--card-bg); border: 1px solid var(--border); border-radius: 28px; padding: 32px; box-shadow: 0 12px 30px rgba(0,0,0,0.05); margin-bottom: 32px;
//   transition: background 0.3s ease, border 0.3s ease;
//   @media (max-width: 768px) { padding: 20px; border-radius: 22px; }
// `;

// const HeaderRow = styled.div`
//   display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 16px; margin-bottom: 24px;
// `;

// const SectionTitle = styled.h2` margin: 0; font-size: clamp(1.2rem, 1rem + 0.6vw, 1.6rem); font-weight: 900; color: var(--text-main); display: flex; align-items: center; gap: 12px; `;

// const GlobalMonthSelect = styled.select`
//   padding: 8px 16px; border-radius: 12px; border: 2px solid ${({ $isDarkMode }) => $isDarkMode ? '#22c55e' : '#86efac'}; 
//   font-size: 1.1rem; font-weight: 800; color: #16a34a; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.1)' : '#f0fdf4'}; 
//   outline: none; cursor: pointer; transition: all 0.2s;
//   &:focus { border-color: #16a34a; box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.1); }
// `;

// const Subtitle = styled.p` color: var(--text-soft); margin: 0; font-size: 0.95rem; line-height: 1.6; max-width: 800px; `;

// const StaffInfoBox = styled.div`
//   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.05)' : '#eff6ff'};
//   border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#1e3a8a' : '#bfdbfe'};
//   padding: 16px 20px; border-radius: 16px; margin-bottom: 24px; display: inline-flex; align-items: center; gap: 16px; flex-wrap: wrap;
// `;

// const StaffName = styled.div` font-size: 1.1rem; font-weight: 800; color: ${({ $isDarkMode }) => $isDarkMode ? '#93c5fd' : '#1e40af'}; `;
// const StaffRole = styled.div` font-size: 0.9rem; font-weight: 600; color: var(--text-soft); background: var(--card-bg); padding: 4px 10px; border-radius: 999px; border: 1px solid var(--border); `;

// /* ================= TABLE STYLES ================= */
// const TableWrapper = styled.div`
//   width: 100%; overflow-x: auto; border-radius: 14px; border: 1px solid var(--table-border);
// `;

// const Table = styled.table`
//   width: 100%; border-collapse: separate; border-spacing: 0; background: transparent; table-layout: fixed; min-width: 1200px;
// `;

// const Th = styled.th`
//   background: var(--table-header-bg); padding: 14px 10px; text-align: left; font-size: 12px; font-weight: 800; 
//   color: ${({ $isDarkMode }) => $isDarkMode ? '#86efac' : '#15803d'}; border-bottom: 1px solid var(--table-border); vertical-align: middle;
//   &:first-child { border-top-left-radius: 14px; } &:last-child { border-top-right-radius: 14px; }
// `;

// const Td = styled.td`
//   padding: 14px 10px; border-bottom: 1px solid var(--table-border); vertical-align: top;
// `;

// const Serial = styled.div`
//   width: 28px; height: 28px; display: grid; place-items: center; border-radius: 50%; 
//   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.15)' : '#f0fdf4'}; 
//   color: ${({ $isDarkMode }) => $isDarkMode ? '#86efac' : '#15803d'}; font-weight: 800; font-size: 0.85rem;
// `;

// const AttributeBox = styled.div`
//   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.05)' : '#f0fdf4'}; 
//   padding: 8px 12px; border-left: 4px solid #22c55e; border-radius: 8px; font-weight: 700; 
//   color: ${({ $isDarkMode }) => $isDarkMode ? '#bbf7d0' : '#14532d'}; font-size: 0.85rem; word-wrap: break-word;
// `;

// const DisabledInput = styled.div`
//   min-height: 32px; border: 1px solid var(--input-border); background: ${({ $isDarkMode }) => $isDarkMode ? 'var(--input-bg)' : '#f8fafc'};
//   color: var(--text-soft); border-radius: 6px; padding: 8px; line-height: 1.4; white-space: pre-wrap; font-size: 13px;
// `;

// const SmallScore = styled.div`
//   width: 36px; height: 36px; display: inline-flex; align-items: center; justify-content: center; border-radius: 6px;
//   border: 1px solid var(--input-border); background: ${({ $isDarkMode }) => $isDarkMode ? 'var(--input-bg)' : '#f8fafc'}; 
//   font-weight: 800; color: var(--text-soft); font-size: 13px;
// `;

// const Select = styled.select`
//   width: 100%; padding: 10px; border-radius: 8px; border: 2px solid ${({ $isDarkMode }) => $isDarkMode ? '#14532d' : '#86efac'}; 
//   font-size: 13px; font-weight: 700; color: var(--text-main); background: var(--input-bg); outline: none; transition: all 0.2s;
//   &:focus { border-color: #22c55e; box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15); }
// `;

// // 🔥 Smaller select for the weekly slots to fit all 5 columns cleanly
// const WeeklySelect = styled.select`
//   width: 100%; padding: 6px; border-radius: 6px; border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#14532d' : '#86efac'}; 
//   font-size: 12px; font-weight: 700; color: var(--text-main); background: var(--input-bg); outline: none; transition: all 0.2s;
//   &:focus { border-color: #22c55e; box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15); }
// `;

// const Textarea = styled.textarea`
//   width: 100%; min-height: 60px; padding: 10px; border: 1px solid var(--input-border); border-radius: 8px; resize: vertical; 
//   font-size: 13px; line-height: 1.4; background: var(--input-bg); color: var(--text-main); outline: none; box-sizing: border-box;
//   &:focus { border-color: #22c55e; box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15); }
// `;

// /* 🔥 UPDATED: Weekly Input Grid now fits 5 columns 🔥 */
// const WeeklyInputGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(5, 1fr);
//   gap: 4px;
// `;

// const WeeklyInputLabel = styled.div`
//   font-size: 8px;
//   color: var(--text-soft);
//   text-align: center;
//   font-weight: 800;
//   text-transform: uppercase;
//   margin-bottom: 2px;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// `;

// /* ================= SCORE CALCULATION BOXES ================= */
// const CalcGrid = styled.div` display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-top: 24px; @media (max-width: 900px) { grid-template-columns: 1fr; } `;

// const CalcBox = styled.div`
//   padding: 24px; border-radius: 20px; border-left: 5px solid; line-height: 1.75; box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
//   background: ${({ variant, $isDarkMode }) => 
//     variant === "admin" ? ($isDarkMode ? 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)' : "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)") :
//     variant === "supervisor" ? ($isDarkMode ? 'linear-gradient(135deg, #064e3b 0%, #14532d 100%)' : "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)") :
//     ($isDarkMode ? 'linear-gradient(135deg, #1e293b 0%, #334155 100%)' : "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)")
//   };
//   border-left-color: ${({ variant }) => variant === "admin" ? "#8b5cf6" : variant === "supervisor" ? "#16a34a" : "#64748b"};
// `;

// const CalcTitle = styled.div`
//   font-size: 1.05rem; font-weight: 900; margin-bottom: 8px;
//   color: ${({ variant, $isDarkMode }) => variant === "admin" ? ($isDarkMode ? "#c4b5fd" : "#4c1d95") : variant === "supervisor" ? ($isDarkMode ? "#4ade80" : "#16a34a") : ($isDarkMode ? "#cbd5e1" : "#475569")};
// `;

// const CalcLine = styled.div`
//   font-size: 0.95rem; font-weight: ${({ strong }) => strong ? 800 : 500};
//   color: ${({ variant, $isDarkMode }) => variant === "admin" ? ($isDarkMode ? "#ddd6fe" : "#5b21b6") : variant === "supervisor" ? ($isDarkMode ? "#86efac" : "#15803d") : ($isDarkMode ? "#f8fafc" : "#334155")};
// `;

// /* ================= ACTIONS & STATES ================= */
// const ActionWrap = styled.div` display: flex; width: 100%; margin-top: 32px; `;

// const SubmitButton = styled.button`
//   appearance: none; border: none; outline: none; border-radius: 16px; padding: 18px 36px; width: 100%;
//   background: ${({ disabled, success }) => disabled && !success ? "linear-gradient(135deg, #94a3b8, #cbd5e1)" : "linear-gradient(135deg, #16a34a, #22c55e)"}; 
//   color: white; font-size: 1.1rem; font-weight: 800; cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
//   box-shadow: ${({ disabled, success }) => disabled && !success ? "none" : "0 14px 28px rgba(34, 197, 94, 0.25)"}; transition: all 0.2s ease;
//   &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 18px 30px rgba(34, 197, 94, 0.3); }
// `;

// const CenterState = styled.div` min-height: 50vh; display: grid; place-items: center; `;
// const StateCard = styled.div` width: min(460px, 100%); background: var(--card-bg); border: 1px solid var(--border); border-radius: 24px; padding: 32px; text-align: center; box-shadow: var(--shadow-md); `;
// const Spinner = styled.div` width: 46px; height: 46px; margin: 0 auto 18px; border-radius: 50%; border: 4px solid var(--border); border-top-color: #16a34a; animation: spin 0.8s linear infinite; @keyframes spin { to { transform: rotate(360deg); } } `;
// const StateTitle = styled.h3` margin: 0 0 8px; font-size: 1.2rem; color: var(--text-main); font-weight: 800; `;
// const StateText = styled.p` margin: 10px 0 0; color: var(--text-soft); line-height: 1.6; `;

// /* ================= COMPONENT ================= */
// const AdminAppraisalForm = ({ user, collapsed, setCollapsed }) => {
//   const { isDarkMode } = useTheme();
//   const { userId } = useParams(); 
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [savedRecently, setSavedRecently] = useState(false);
  
//   const [staffInfo, setStaffInfo] = useState(null);
//   const [appraisalId, setAppraisalId] = useState(null);
//   const [section4Data, setSection4Data] = useState([]);
  
//   const availableMonths = useMemo(() => generateMonthOptions(), []);
  
//   const [selectedMonth, setSelectedMonth] = useState(
//     localStorage.getItem("adminViewMonth") || getCurrentMonthName()
//   );

//   useEffect(() => {
//     localStorage.setItem("adminViewMonth", selectedMonth);
//   }, [selectedMonth]);
  
//   // Generate the 5 week labels for the current selected month
//   const weekLabels = useMemo(() => generateWeekLabels(selectedMonth), [selectedMonth]);

//   useEffect(() => {
//     const fetchAppraisal = async () => {
//       if (!userId) return;
//       setLoading(true);
//       try {
//         const res = await api.get(`/appraisal/admin/user/${userId}/${selectedMonth}`);
        
//         if (res.data.success && res.data.data) {
//           const appraisal = res.data.data;
//           setAppraisalId(appraisal._id);
//           setStaffInfo(appraisal.userId || appraisal.user || appraisal.userDetails || {});
          
//           const mergedData = complianceItems.map((defaultItem, index) => {
//             const existing = (appraisal.section4 || []).find(dbItem => dbItem.attribute === defaultItem.attribute);
            
//             // Initialize 5 weekly scores for items 12-15 (indices 11-14)
//             let weeklyScores = existing?.weeklyScores || { week1: "", week2: "", week3: "", week4: "", week5: "" };

//             return {
//               ...defaultItem,
//               staffScore: existing?.staffScore || "",
//               supervisorScore: existing?.supervisorScore || "",
//               supervisorComments: existing?.supervisorComments || "",
//               adminComments: existing?.adminComments || "",
//               weeklyScores: index >= 11 && index <= 14 ? weeklyScores : null
//             };
//           });
//           setSection4Data(mergedData);
//         } else {
//           setAppraisalId(null);
//           setStaffInfo(null);
//           setSection4Data(complianceItems.map((item, index) => ({ 
//             ...item, 
//             staffScore: "", 
//             supervisorScore: "", 
//             adminComments: "",
//             weeklyScores: index >= 11 && index <= 14 ? { week1: "", week2: "", week3: "", week4: "", week5: "" } : null
//           })));
//         }
//       } catch (err) {
//         console.error("Error fetching appraisal:", err);
//         setAppraisalId(null);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchAppraisal();
//   }, [userId, selectedMonth]);

//   const handleAdminScore = (index, value) => {
//     setSection4Data(prev => prev.map((item, i) => i === index ? { ...item, supervisorScore: value } : item));
//   };

//   const handleWeeklyScore = (itemIndex, weekKey, value) => {
//     setSection4Data(prev => {
//       const nextData = [...prev];
//       const item = { ...nextData[itemIndex] };
//       const newWeeklyScores = { ...item.weeklyScores, [weekKey]: value };
      
//       const scores = Object.values(newWeeklyScores).map(s => parseScoreValue(s)).filter(s => s !== null);
//       let avgScore = "";
//       if (scores.length > 0) {
//         const sum = scores.reduce((a, b) => a + b, 0);
//         avgScore = (sum / scores.length).toFixed(1); 
//       }

//       item.weeklyScores = newWeeklyScores;
//       item.supervisorScore = avgScore; 
//       nextData[itemIndex] = item;
//       return nextData;
//     });
//   };

//   const handleAdminComment = (index, value) => {
//     setSection4Data(prev => prev.map((item, i) => i === index ? { ...item, adminComments: value } : item));
//   };

//   const calculateScores = () => {
//     const calcGroup = (scoreKey, maxScore = 10, bonusIndex = 15) => {
//       const validScores = section4Data.filter((item, i) => i < 15).map(item => parseScoreValue(item[scoreKey])).filter(s => s !== null);
//       const bonusScore = parseScoreValue(section4Data[bonusIndex]?.[scoreKey]) || 0;
      
//       if (validScores.length === 0) return { total: 0, completed: 0, rawAvg: 0 };
      
//       const sum = validScores.reduce((acc, val) => acc + val, 0) + bonusScore;
//       const avg = sum / validScores.length;
//       let total = (avg / 5) * maxScore;
//       total = Math.min(total, maxScore); 
      
//       return { total: total.toFixed(1), completed: validScores.length + (bonusScore > 0 ? 1 : 0), rawAvg: avg.toFixed(2) };
//     };

//     return {
//       staff: calcGroup('staffScore'),
//       supervisor: calcGroup('supervisorScore'), 
//       admin: calcGroup('supervisorScore') 
//     };
//   };

//   const scores = calculateScores();

//   const handleSave = async () => {
//     if (!appraisalId) return alert("No appraisal document found to update for this month.");
    
//     setSaving(true);
//     try {
//       const payload = {
//         section4: section4Data,
//         summary: {
//           section4: parseFloat(scores.admin.total) || 0,
//           hodOverallComments: "" 
//         }
//       };

//       await api.put(`/appraisal/admin-score/${appraisalId}`, payload);
      
//       setSavedRecently(true);
//       setTimeout(() => setSavedRecently(false), 3000);
//     } catch (error) {
//       console.error(error);
//       alert("Failed to save Admin assessment.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (loading) {
//     return (
//       <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
//         <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//         <Main>
//           <CenterState>
//             <StateCard>
//               <Spinner />
//               <StateTitle>Accessing Records...</StateTitle>
//               <StateText>Retrieving compliance logs for {selectedMonth}.</StateText>
//             </StateCard>
//           </CenterState>
//         </Main>
//       </Container>
//     );
//   }

//   return (
//     <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
//       <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//       <DashboardHeader user={user} collapsed={collapsed} />

//       <Main>
//         <BackButton onClick={() => navigate('/admin/dashboard')}>
//           <FaArrowLeft /> Back to Directory
//         </BackButton>

//         <SectionCard>
//           <HeaderRow>
//             <SectionTitle><FaShieldAlt style={{color: '#16a34a'}}/> Compliance Oversight</SectionTitle>
//             <GlobalMonthSelect $isDarkMode={isDarkMode} value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
//               {availableMonths.map(m => <option key={m} value={m}>{m}</option>)}
//             </GlobalMonthSelect>
//           </HeaderRow>
          
//           <Subtitle>Review the compliance adherence scores for this specific staff member. Items 1-9 are read-only. You may override or finalize the assessment for items 10-15 using the Supervisor Score column.</Subtitle>

//           {staffInfo?.firstName && (
//             <StaffInfoBox $isDarkMode={isDarkMode} style={{ marginTop: '20px' }}>
//               <StaffName $isDarkMode={isDarkMode}>{staffInfo.firstName} {staffInfo.surname}</StaffName>
//               <StaffRole>{staffInfo.unit || 'No Unit Assigned'}</StaffRole>
//             </StaffInfoBox>
//           )}

//           {!appraisalId ? (
//             <CenterState style={{ minHeight: '30vh' }}>
//               <StateTitle>No Record Found</StateTitle>
//               <StateText>This user has not initiated an appraisal draft for {selectedMonth}.</StateText>
//             </CenterState>
//           ) : (
//             <>
//               <TableWrapper>
//                 <Table>
//                   <colgroup>
//                     <col style={{ width: "4%" }} />
//                     <col style={{ width: "16%" }} />
//                     <col style={{ width: "30%" }} />
//                     <col style={{ width: "6%" }} />
//                     <col style={{ width: "20%" }} /> 
//                     <col style={{ width: "24%" }} />
//                   </colgroup>
//                   <thead>
//                     <tr>
//                       <Th $isDarkMode={isDarkMode}>S/N</Th>
//                       <Th $isDarkMode={isDarkMode}>Protocol</Th>
//                       <Th $isDarkMode={isDarkMode}>Description</Th>
//                       <Th $isDarkMode={isDarkMode}>Staff<br/>Score</Th>
//                       <Th $isDarkMode={isDarkMode}>Supervisor's Score</Th>
//                       <Th $isDarkMode={isDarkMode}>Admin Comments</Th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {section4Data.map((item, index) => {
//                       const isWeeklyScoreItem = index >= 11 && index <= 14; // Items 12-15
//                       const isEditableByAdmin = index >= 9 && index <= 14; // Items 10-15

//                       return (
//                         <tr key={index}>
//                           <Td><Serial $isDarkMode={isDarkMode}>{index + 1}</Serial></Td>
//                           <Td><AttributeBox $isDarkMode={isDarkMode}>{item.attribute}</AttributeBox></Td>
//                           <Td><DisabledInput $isDarkMode={isDarkMode}>{item.description}</DisabledInput></Td>
//                           <Td><SmallScore $isDarkMode={isDarkMode}>{ScoreValue(item.staffScore)}</SmallScore></Td>
                          
//                           <Td>
//                             {/* 🔥 Check Edit Permissions 🔥 */}
//                             {isEditableByAdmin ? (
//                               /* Admin Can Edit Items 10-15 */
//                               isWeeklyScoreItem ? (
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                   <WeeklyInputGrid>
//                                     {['week1', 'week2', 'week3', 'week4', 'week5'].map((weekKey, idx) => (
//                                       <div key={weekKey}>
//                                         <WeeklyInputLabel title={weekLabels[idx]}>{weekLabels[idx]}</WeeklyInputLabel>
//                                         <WeeklySelect value={item.weeklyScores?.[weekKey] ?? ""} onChange={(e) => handleWeeklyScore(index, weekKey, e.target.value)} $isDarkMode={isDarkMode}>
//                                           {weeklyRatingScale.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//                                         </WeeklySelect>
//                                       </div>
//                                     ))}
//                                   </WeeklyInputGrid>
//                                   <div style={{ fontSize: '11px', color: 'var(--text-soft)', textAlign: 'right' }}>
//                                     Average Score: <strong style={{ color: 'var(--text-main)' }}>{item.supervisorScore || "0"}</strong>
//                                   </div>
//                                 </div>
//                               ) : (
//                                 /* Standard Input for Items 10-11 */
//                                 <Select value={item.supervisorScore ?? ""} onChange={(e) => handleAdminScore(index, e.target.value)} $isDarkMode={isDarkMode}>
//                                   {standardRatingScale.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//                                 </Select>
//                               )
//                             ) : (
//                               /* Admin Cannot Edit Items 1-9 */
//                               <SmallScore muted $isDarkMode={isDarkMode}>{ScoreValue(item.supervisorScore)}</SmallScore>
//                             )}
//                           </Td>

//                           <Td>
//                             {isEditableByAdmin ? (
//                               <Textarea 
//                                 value={item.adminComments || ""}
//                                 onChange={(e) => handleAdminComment(index, e.target.value)}
//                                 placeholder="Add administrative feedback..."
//                                 $isDarkMode={isDarkMode}
//                               />
//                             ) : (
//                               <DisabledInput $isDarkMode={isDarkMode}>
//                                 {item.adminComments || "No administrative feedback."}
//                               </DisabledInput>
//                             )}
//                           </Td>
//                         </tr>
//                       )
//                     })}
//                   </tbody>
//                 </Table>
//               </TableWrapper>

//               <CalcGrid>
//                 <CalcBox variant="staff" $isDarkMode={isDarkMode}>
//                   <CalcTitle variant="staff" $isDarkMode={isDarkMode}>Staff Self-Assessment</CalcTitle>
//                   <CalcLine variant="staff" $isDarkMode={isDarkMode}>Items Scored: {scores.staff.completed}</CalcLine>
//                   <CalcLine variant="staff" $isDarkMode={isDarkMode}>Average: {scores.staff.rawAvg}</CalcLine>
//                   <CalcLine variant="staff" $isDarkMode={isDarkMode} strong>TOTAL: {scores.staff.total} / 10</CalcLine>
//                 </CalcBox>
                
//                 <CalcBox variant="supervisor" $isDarkMode={isDarkMode}>
//                   <CalcTitle variant="supervisor" $isDarkMode={isDarkMode}>Supervisor Assessment</CalcTitle>
//                   <CalcLine variant="supervisor" $isDarkMode={isDarkMode}>Items Scored: {scores.supervisor.completed}</CalcLine>
//                   <CalcLine variant="supervisor" $isDarkMode={isDarkMode}>Average: {scores.supervisor.rawAvg}</CalcLine>
//                   <CalcLine variant="supervisor" $isDarkMode={isDarkMode} strong>TOTAL: {scores.supervisor.total} / 10</CalcLine>
//                 </CalcBox>
                
//                 <CalcBox variant="admin" $isDarkMode={isDarkMode}>
//                   <CalcTitle variant="admin" $isDarkMode={isDarkMode}>Admin Final Assessment</CalcTitle>
//                   <CalcLine variant="admin" $isDarkMode={isDarkMode}>Items Scored: {scores.admin.completed}</CalcLine>
//                   <CalcLine variant="admin" $isDarkMode={isDarkMode}>Average: {scores.admin.rawAvg}</CalcLine>
//                   <CalcLine variant="admin" $isDarkMode={isDarkMode} strong>TOTAL: {scores.admin.total} / 10</CalcLine>
//                 </CalcBox>
//               </CalcGrid>

//               <ActionWrap>
//                 <SubmitButton onClick={handleSave} disabled={saving || savedRecently} success={savedRecently}>
//                   {saving ? "Processing..." : savedRecently ? "Oversight Logged Successfully! ✓" : "Commit Admin Evaluation"}
//                 </SubmitButton>
//               </ActionWrap>
//             </>
//           )}
//         </SectionCard>
//       </Main>
//       <Footer />
//     </Container>
//   );
// };

// export default AdminAppraisalForm;





import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { useParams, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaShieldAlt } from "react-icons/fa";
import NavBarSuper from "./NavBarSuper";
import DashboardHeader from "./DashboardHeader";
import Footer from "./Footer";
import api from "../api";
import { useTheme } from "../App";

/* ================= HELPERS ================= */
const getCurrentMonthName = () => {
  const date = new Date();
  return date.toLocaleString("default", { month: "long", year: "numeric" });
};

const generateMonthOptions = () => {
  const months = [];
  const date = new Date();
  date.setMonth(date.getMonth() - 3); 
  for (let i = 0; i < 12; i++) {
    months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
    date.setMonth(date.getMonth() + 1);
  }
  return months;
};

const generateWeekLabels = (periodString) => {
  const defaultLabels = ["Wk 1", "Wk 2", "Wk 3", "Wk 4", "Wk 5"];
  if (!periodString) return defaultLabels;
  
  const d = new Date(periodString);
  if (isNaN(d.getTime())) return defaultLabels;
  
  const y = d.getFullYear();
  const m = d.getMonth();
  const lastDay = new Date(y, m + 1, 0); 
  
  const labels = ["Wk 1", "Wk 2", "Wk 3", "Wk 4"];
  
  if (lastDay.getDay() !== 6) { 
    const nextMonth = new Date(y, m + 1, 1).toLocaleString('default', { month: 'short' });
    labels.push(`Wk 5 / ${nextMonth} Wk 1`);
  } else {
    labels.push("Wk 5");
  }
  
  return labels;
};

const parseScoreValue = (value) => {
  if (value === "N/A" || value === "" || value == null) return null;
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};

const ScoreValue = (value) => {
  if (value === "N/A" || value === "" || value == null) return null;
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};

const formatScore = (value) => Number(value || 0).toFixed(1);

const complianceItems = [
  { attribute: "Feedback", description: "Measures the progress and status of work with the use of relevant tools. Gives quality and consistent information on assigned tasks." },
  { attribute: "Responsiveness to official communication", description: "Is reachable and responsive on Kingschat and official communication platforms." },
  { attribute: "Care and Maintenance of office space and equipment", description: "Consistently maintains a clean, tidy and orderly office space. Takes good care of all equipment, keeping them in optimal working condition." },
  { attribute: "Ministry Programs", description: "Participates in Ministry Global Programs such as Your Loveworld, GDOP, etc." },
  { attribute: "Church Services and Meetings", description: "Consistently and punctually at Sunday and Wednesday Church Services, Prayer Services." },
  { attribute: "Monthly Goals", description: "Promptly submits monthly goals before 1st 12.00am of each month." },
  { attribute: "Weekly Goals", description: "Promptly submits weekly goals on or before Saturday 11.59pm." },
  { attribute: "Weekly Reporting", description: "Promptly submits all weekly reports on or before Saturday 11:59pm." },
  { attribute: "Performance Reporting", description: "Promptly submits performance appraisal form on or before 1st of each month." },
  { attribute: "Online publicity and awareness creation", description: "Consistently publicizes, promotes and creates awareness of departmental products and activities online and physically as required. (Free type)" },
  { attribute: "Staff Trainings", description: "Consistently and punctually at Staff Training Programs and products, STDL, other Ministry trainings for staff." },
  { attribute: "Office Attendance", description: "Consistently and punctually at the office." },
  { attribute: "Office Prayer Meetings", description: "Consistently and punctually at Staff Office Prayer Meetings (onsite and online)." },
  { attribute: "Staff Chapel & Care Group Meetings", description: "Consistently and punctually at Staff Chapel Services & Staff Care Group Meetings."},
  { attribute: "Uniforms", description: "Wears clean, proper and appropriate uniforms." },
];

const standardRatingScale = [
  { value: "", label: "Select..." },
  { value: "N/A", label: "N/A" },
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" }
];

const weeklyRatingScale = [
  { value: "", label: "-" },
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" }
];

/* ================= PAGE LAYOUT & THEME VARIABLES ================= */
const Container = styled.div`
  --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
  --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.96)'};
  --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
  --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
  --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
  --input-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'};
  --table-header-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#f0fdf4'};
  --table-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#bbf7d0'};

  min-height: 100vh;
  background: var(--page-bg);
  color: var(--text-main);
  margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
  transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;

  @media (max-width: 1023px) { margin-left: 0; }
`;

const Main = styled.main`
  width: 100%; 
  padding: 94px 24px 80px; 
  box-sizing: border-box;
  @media (max-width: 1023px) { padding: 86px 16px 80px; }
`;

/* ================= COMPONENTS ================= */
const BackButton = styled.button` 
  display: inline-flex; align-items: center; gap: 8px; background: none; border: none;
  color: #16a34a; font-weight: 800; font-size: 1rem; cursor: pointer; transition: transform 0.2s ease; padding: 0; margin-bottom: 24px;
  &:hover { transform: translateX(-4px); text-decoration: underline; }
`;

const SectionCard = styled.section`
  background: var(--card-bg); border: 1px solid var(--border); border-radius: 28px; padding: 32px; box-shadow: 0 12px 30px rgba(0,0,0,0.05); margin-bottom: 32px;
  transition: background 0.3s ease, border 0.3s ease;
  @media (max-width: 768px) { padding: 20px; border-radius: 22px; }
`;

const HeaderRow = styled.div`
  display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 16px; margin-bottom: 24px;
`;

const SectionTitle = styled.h2` margin: 0; font-size: clamp(1.2rem, 1rem + 0.6vw, 1.6rem); font-weight: 900; color: var(--text-main); display: flex; align-items: center; gap: 12px; `;

const GlobalMonthSelect = styled.select`
  padding: 8px 16px; border-radius: 12px; border: 2px solid ${({ $isDarkMode }) => $isDarkMode ? '#22c55e' : '#86efac'}; 
  font-size: 1.1rem; font-weight: 800; color: #16a34a; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.1)' : '#f0fdf4'}; 
  outline: none; cursor: pointer; transition: all 0.2s;
  &:focus { border-color: #16a34a; box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.1); }
`;

const Subtitle = styled.p` color: var(--text-soft); margin: 0; font-size: 0.95rem; line-height: 1.6; max-width: 800px; `;

const StaffInfoBox = styled.div`
  background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.05)' : '#eff6ff'};
  border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#1e3a8a' : '#bfdbfe'};
  padding: 16px 20px; border-radius: 16px; margin-bottom: 24px; display: inline-flex; align-items: center; gap: 16px; flex-wrap: wrap;
`;

const StaffName = styled.div` font-size: 1.1rem; font-weight: 800; color: ${({ $isDarkMode }) => $isDarkMode ? '#93c5fd' : '#1e40af'}; `;
const StaffRole = styled.div` font-size: 0.9rem; font-weight: 600; color: var(--text-soft); background: var(--card-bg); padding: 4px 10px; border-radius: 999px; border: 1px solid var(--border); `;

/* ================= TABLE STYLES ================= */
const TableWrapper = styled.div`
  width: 100%; overflow-x: auto; border-radius: 14px; border: 1px solid var(--table-border);
`;

const Table = styled.table`
  width: 100%; border-collapse: separate; border-spacing: 0; background: transparent; table-layout: fixed; min-width: 1200px;
`;

const Th = styled.th`
  background: var(--table-header-bg); padding: 14px 10px; text-align: left; font-size: 12px; font-weight: 800; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#86efac' : '#15803d'}; border-bottom: 1px solid var(--table-border); vertical-align: middle;
  &:first-child { border-top-left-radius: 14px; } &:last-child { border-top-right-radius: 14px; }
`;

const Td = styled.td`
  padding: 14px 10px; border-bottom: 1px solid var(--table-border); vertical-align: top;
`;

const Serial = styled.div`
  width: 28px; height: 28px; display: grid; place-items: center; border-radius: 50%; 
  background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.15)' : '#f0fdf4'}; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#86efac' : '#15803d'}; font-weight: 800; font-size: 0.85rem;
`;

const AttributeBox = styled.div`
  background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(34, 197, 94, 0.05)' : '#f0fdf4'}; 
  padding: 8px 12px; border-left: 4px solid #22c55e; border-radius: 8px; font-weight: 700; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#bbf7d0' : '#14532d'}; font-size: 0.85rem; word-wrap: break-word;
`;

const DisabledInput = styled.div`
  min-height: 32px; border: 1px solid var(--input-border); background: ${({ $isDarkMode }) => $isDarkMode ? 'var(--input-bg)' : '#f8fafc'};
  color: var(--text-soft); border-radius: 6px; padding: 8px; line-height: 1.4; white-space: pre-wrap; font-size: 13px;
`;

const SmallScore = styled.div`
  width: 36px; height: 36px; display: inline-flex; align-items: center; justify-content: center; border-radius: 6px;
  border: 1px solid var(--input-border); background: ${({ $isDarkMode }) => $isDarkMode ? 'var(--input-bg)' : '#f8fafc'}; 
  font-weight: 800; color: var(--text-soft); font-size: 13px;
`;

const Select = styled.select`
  width: 100%; padding: 10px; border-radius: 8px; border: 2px solid ${({ $isDarkMode }) => $isDarkMode ? '#14532d' : '#86efac'}; 
  font-size: 13px; font-weight: 700; color: var(--text-main); background: var(--input-bg); outline: none; transition: all 0.2s;
  &:focus { border-color: #22c55e; box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15); }
`;

const WeeklySelect = styled.select`
  width: 100%; padding: 6px; border-radius: 6px; border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#14532d' : '#86efac'}; 
  font-size: 12px; font-weight: 700; color: var(--text-main); background: var(--input-bg); outline: none; transition: all 0.2s;
  &:focus { border-color: #22c55e; box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15); }
`;

const Textarea = styled.textarea`
  width: 100%; min-height: 60px; padding: 10px; border: 1px solid var(--input-border); border-radius: 8px; resize: vertical; 
  font-size: 13px; line-height: 1.4; background: var(--input-bg); color: var(--text-main); outline: none; box-sizing: border-box;
  &:focus { border-color: #22c55e; box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15); }
`;

const WeeklyInputGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 4px;
`;

const WeeklyInputLabel = styled.div`
  font-size: 8px;
  color: var(--text-soft);
  text-align: center;
  font-weight: 800;
  text-transform: uppercase;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/* ================= SCORE CALCULATION BOXES ================= */
const CalcGrid = styled.div` display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-top: 24px; @media (max-width: 900px) { grid-template-columns: 1fr; } `;

const CalcBox = styled.div`
  padding: 24px; border-radius: 20px; border-left: 5px solid; line-height: 1.75; box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
  background: ${({ variant, $isDarkMode }) => 
    variant === "admin" ? ($isDarkMode ? 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)' : "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)") :
    variant === "supervisor" ? ($isDarkMode ? 'linear-gradient(135deg, #064e3b 0%, #14532d 100%)' : "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)") :
    ($isDarkMode ? 'linear-gradient(135deg, #1e293b 0%, #334155 100%)' : "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)")
  };
  border-left-color: ${({ variant }) => variant === "admin" ? "#8b5cf6" : variant === "supervisor" ? "#16a34a" : "#64748b"};
`;

const CalcTitle = styled.div`
  font-size: 1.05rem; font-weight: 900; margin-bottom: 8px;
  color: ${({ variant, $isDarkMode }) => variant === "admin" ? ($isDarkMode ? "#c4b5fd" : "#4c1d95") : variant === "supervisor" ? ($isDarkMode ? "#4ade80" : "#16a34a") : ($isDarkMode ? "#cbd5e1" : "#475569")};
`;

const CalcLine = styled.div`
  font-size: 0.95rem; font-weight: ${({ strong }) => strong ? 800 : 500};
  color: ${({ variant, $isDarkMode }) => variant === "admin" ? ($isDarkMode ? "#ddd6fe" : "#5b21b6") : variant === "supervisor" ? ($isDarkMode ? "#86efac" : "#15803d") : ($isDarkMode ? "#f8fafc" : "#334155")};
`;

/* ================= ACTIONS & STATES ================= */
const ActionWrap = styled.div` display: flex; width: 100%; margin-top: 32px; `;

const SubmitButton = styled.button`
  appearance: none; border: none; outline: none; border-radius: 16px; padding: 18px 36px; width: 100%;
  background: ${({ disabled, success }) => disabled && !success ? "linear-gradient(135deg, #94a3b8, #cbd5e1)" : "linear-gradient(135deg, #16a34a, #22c55e)"}; 
  color: white; font-size: 1.1rem; font-weight: 800; cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  box-shadow: ${({ disabled, success }) => disabled && !success ? "none" : "0 14px 28px rgba(34, 197, 94, 0.25)"}; transition: all 0.2s ease;
  &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 18px 30px rgba(34, 197, 94, 0.3); }
`;

const CenterState = styled.div` min-height: 50vh; display: grid; place-items: center; `;
const StateCard = styled.div` width: min(460px, 100%); background: var(--card-bg); border: 1px solid var(--border); border-radius: 24px; padding: 32px; text-align: center; box-shadow: var(--shadow-md); `;
const Spinner = styled.div` width: 46px; height: 46px; margin: 0 auto 18px; border-radius: 50%; border: 4px solid var(--border); border-top-color: #16a34a; animation: spin 0.8s linear infinite; @keyframes spin { to { transform: rotate(360deg); } } `;
const StateTitle = styled.h3` margin: 0 0 8px; font-size: 1.2rem; color: var(--text-main); font-weight: 800; `;
const StateText = styled.p` margin: 10px 0 0; color: var(--text-soft); line-height: 1.6; `;

/* ================= COMPONENT ================= */
const AdminAppraisalForm = ({ user, collapsed, setCollapsed }) => {
  const { isDarkMode } = useTheme();
  const { userId } = useParams(); 
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [savedRecently, setSavedRecently] = useState(false);
  
  const [staffInfo, setStaffInfo] = useState(null);
  const [appraisalId, setAppraisalId] = useState(null);
  const [section4Data, setSection4Data] = useState([]);
  
  const availableMonths = useMemo(() => generateMonthOptions(), []);
  
  const [selectedMonth, setSelectedMonth] = useState(
    localStorage.getItem("adminViewMonth") || getCurrentMonthName()
  );

  useEffect(() => {
    localStorage.setItem("adminViewMonth", selectedMonth);
  }, [selectedMonth]);
  
  // Generate the 5 week labels for the current selected month
  const weekLabels = useMemo(() => generateWeekLabels(selectedMonth), [selectedMonth]);

  useEffect(() => {
    const fetchAppraisal = async () => {
      if (!userId) return;
      setLoading(true);
      try {
        const res = await api.get(`/appraisal/admin/user/${userId}/${selectedMonth}`);
        
        if (res.data.success) {
          const appraisal = res.data.data;
          
          // Even if appraisal is null, the new backend logic passes the staff details
          setStaffInfo(appraisal?.userId || res.data.staff || {});
          
          if (appraisal) {
            setAppraisalId(appraisal._id);
            const mergedData = complianceItems.map((defaultItem, index) => {
              const existing = (appraisal.section4 || []).find(dbItem => dbItem.attribute === defaultItem.attribute);
              
              let weeklyScores = existing?.weeklyScores || { week1: "", week2: "", week3: "", week4: "", week5: "" };

              return {
                ...defaultItem,
                staffScore: existing?.staffScore || "",
                supervisorScore: existing?.supervisorScore || "",
                supervisorComments: existing?.supervisorComments || "",
                adminComments: existing?.adminComments || "",
                weeklyScores: index >= 11 && index <= 14 ? weeklyScores : null
              };
            });
            setSection4Data(mergedData);
          } else {
            // Appraisal doesn't exist yet, setup blank template
            setAppraisalId(null);
            setSection4Data(complianceItems.map((item, index) => ({ 
              ...item, 
              staffScore: "", 
              supervisorScore: "", 
              adminComments: "",
              weeklyScores: index >= 11 && index <= 14 ? { week1: "", week2: "", week3: "", week4: "", week5: "" } : null
            })));
          }
        }
      } catch (err) {
        console.error("Error fetching appraisal:", err);
        setAppraisalId(null);
      } finally {
        setLoading(false);
      }
    };
    fetchAppraisal();
  }, [userId, selectedMonth]);

  const handleAdminScore = (index, value) => {
    setSection4Data(prev => prev.map((item, i) => i === index ? { ...item, supervisorScore: value } : item));
  };

  const handleWeeklyScore = (itemIndex, weekKey, value) => {
    setSection4Data(prev => {
      const nextData = [...prev];
      const item = { ...nextData[itemIndex] };
      const newWeeklyScores = { ...item.weeklyScores, [weekKey]: value };
      
      const scores = Object.values(newWeeklyScores).map(s => parseScoreValue(s)).filter(s => s !== null);
      let avgScore = "";
      if (scores.length > 0) {
        const sum = scores.reduce((a, b) => a + b, 0);
        avgScore = (sum / scores.length).toFixed(1); 
      }

      item.weeklyScores = newWeeklyScores;
      item.supervisorScore = avgScore; 
      nextData[itemIndex] = item;
      return nextData;
    });
  };

  const handleAdminComment = (index, value) => {
    setSection4Data(prev => prev.map((item, i) => i === index ? { ...item, adminComments: value } : item));
  };

  const calculateScores = () => {
    const calcGroup = (scoreKey, maxScore = 10, bonusIndex = 15) => {
      const validScores = section4Data.filter((item, i) => i < 15).map(item => parseScoreValue(item[scoreKey])).filter(s => s !== null);
      const bonusScore = parseScoreValue(section4Data[bonusIndex]?.[scoreKey]) || 0;
      
      if (validScores.length === 0) return { total: 0, completed: 0, rawAvg: 0 };
      
      const sum = validScores.reduce((acc, val) => acc + val, 0) + bonusScore;
      const avg = sum / validScores.length;
      let total = (avg / 5) * maxScore;
      total = Math.min(total, maxScore); 
      
      return { total: total.toFixed(1), completed: validScores.length + (bonusScore > 0 ? 1 : 0), rawAvg: avg.toFixed(2) };
    };

    return {
      staff: calcGroup('staffScore'),
      supervisor: calcGroup('supervisorScore'), 
      admin: calcGroup('supervisorScore') 
    };
  };

  const scores = calculateScores();

  const handleSave = async () => {
    setSaving(true);
    try {
      const payload = {
        section4: section4Data,
        summary: {
          section4: parseFloat(scores.admin.total) || 0,
          hodOverallComments: "" 
        }
      };

      // 🔥 Use the new UPSERT endpoint so we can save even if the appraisal doesn't exist yet
      await api.put(`/appraisal/admin-score/upsert/${userId}/${selectedMonth}`, payload);
      
      setSavedRecently(true);
      setTimeout(() => setSavedRecently(false), 3000);
    } catch (error) {
      console.error(error);
      alert("Failed to save Admin assessment.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
        <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
        <Main>
          <CenterState>
            <StateCard>
              <Spinner />
              <StateTitle>Accessing Records...</StateTitle>
              <StateText>Retrieving compliance logs for {selectedMonth}.</StateText>
            </StateCard>
          </CenterState>
        </Main>
      </Container>
    );
  }

  return (
    <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
      <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
      <DashboardHeader user={user} collapsed={collapsed} />

      <Main>
        <BackButton onClick={() => navigate('/admin/dashboard')}>
          <FaArrowLeft /> Back to Directory
        </BackButton>

        <SectionCard>
          <HeaderRow>
            <SectionTitle><FaShieldAlt style={{color: '#16a34a'}}/> Compliance Oversight</SectionTitle>
            <GlobalMonthSelect $isDarkMode={isDarkMode} value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
              {availableMonths.map(m => <option key={m} value={m}>{m}</option>)}
            </GlobalMonthSelect>
          </HeaderRow>
          
          <Subtitle>Review the compliance adherence scores for this specific staff member. Items 1-9 are read-only. You may override or finalize the assessment for items 10-15 using the Supervisor Score column.</Subtitle>

          {staffInfo?.firstName && (
            <StaffInfoBox $isDarkMode={isDarkMode} style={{ marginTop: '20px' }}>
              <StaffName $isDarkMode={isDarkMode}>{staffInfo.firstName} {staffInfo.surname}</StaffName>
              <StaffRole>{staffInfo.unit || staffInfo.department || 'No Unit Assigned'}</StaffRole>
            </StaffInfoBox>
          )}

          <TableWrapper>
            <Table>
              <colgroup>
                <col style={{ width: "4%" }} />
                <col style={{ width: "16%" }} />
                <col style={{ width: "30%" }} />
                <col style={{ width: "6%" }} />
                <col style={{ width: "20%" }} /> 
                <col style={{ width: "24%" }} />
              </colgroup>
              <thead>
                <tr>
                  <Th $isDarkMode={isDarkMode}>S/N</Th>
                  <Th $isDarkMode={isDarkMode}>Protocol</Th>
                  <Th $isDarkMode={isDarkMode}>Description</Th>
                  <Th $isDarkMode={isDarkMode}>Staff<br/>Score</Th>
                  <Th $isDarkMode={isDarkMode}>Supervisor's Score</Th>
                  <Th $isDarkMode={isDarkMode}>Admin Comments</Th>
                </tr>
              </thead>
              <tbody>
                {section4Data.map((item, index) => {
                  const isWeeklyScoreItem = index >= 11 && index <= 14; // Items 12-15
                  
                  // 🔥 Logic Update: If appraisal is missing, only allow items 12-15 to be edited
                  const isAppraisalReady = !!appraisalId;
                  const isEditableByAdmin = isAppraisalReady 
                    ? (index >= 9 && index <= 14)  // Items 10-15 are editable if ready
                    : (index >= 11 && index <= 14); // Only Items 12-15 are editable if not ready

                  return (
                    <tr key={index}>
                      <Td><Serial $isDarkMode={isDarkMode}>{index + 1}</Serial></Td>
                      <Td><AttributeBox $isDarkMode={isDarkMode}>{item.attribute}</AttributeBox></Td>
                      <Td><DisabledInput $isDarkMode={isDarkMode}>{item.description}</DisabledInput></Td>
                      <Td><SmallScore $isDarkMode={isDarkMode}>{ScoreValue(item.staffScore)}</SmallScore></Td>
                      
                      <Td>
                        {/* Check Edit Permissions */}
                        {isEditableByAdmin ? (
                          /* Admin Can Edit */
                          isWeeklyScoreItem ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                              <WeeklyInputGrid>
                                {['week1', 'week2', 'week3', 'week4', 'week5'].map((weekKey, idx) => (
                                  <div key={weekKey}>
                                    <WeeklyInputLabel title={weekLabels[idx]}>{weekLabels[idx]}</WeeklyInputLabel>
                                    <WeeklySelect value={item.weeklyScores?.[weekKey] ?? ""} onChange={(e) => handleWeeklyScore(index, weekKey, e.target.value)} $isDarkMode={isDarkMode}>
                                      {weeklyRatingScale.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                    </WeeklySelect>
                                  </div>
                                ))}
                              </WeeklyInputGrid>
                              <div style={{ fontSize: '11px', color: 'var(--text-soft)', textAlign: 'right' }}>
                                Average Score: <strong style={{ color: 'var(--text-main)' }}>{item.supervisorScore || "0"}</strong>
                              </div>
                            </div>
                          ) : (
                            /* Standard Input for Items 10-11 */
                            <Select value={item.supervisorScore ?? ""} onChange={(e) => handleAdminScore(index, e.target.value)} $isDarkMode={isDarkMode}>
                              {standardRatingScale.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                            </Select>
                          )
                        ) : (
                          /* Admin Cannot Edit this Item right now */
                          <SmallScore muted $isDarkMode={isDarkMode}>{ScoreValue(item.supervisorScore)}</SmallScore>
                        )}
                      </Td>

                      <Td>
                        {isEditableByAdmin ? (
                          <Textarea 
                            value={item.adminComments || ""}
                            onChange={(e) => handleAdminComment(index, e.target.value)}
                            placeholder="Add administrative feedback..."
                            $isDarkMode={isDarkMode}
                          />
                        ) : (
                          <DisabledInput $isDarkMode={isDarkMode}>
                            {item.adminComments || "No administrative feedback."}
                          </DisabledInput>
                        )}
                      </Td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </TableWrapper>

          <CalcGrid>
            <CalcBox variant="staff" $isDarkMode={isDarkMode}>
              <CalcTitle variant="staff" $isDarkMode={isDarkMode}>Staff Self-Assessment</CalcTitle>
              <CalcLine variant="staff" $isDarkMode={isDarkMode}>Items Scored: {scores.staff.completed}</CalcLine>
              <CalcLine variant="staff" $isDarkMode={isDarkMode}>Average: {scores.staff.rawAvg}</CalcLine>
              <CalcLine variant="staff" $isDarkMode={isDarkMode} strong>TOTAL: {scores.staff.total} / 10</CalcLine>
            </CalcBox>
            
            {/* <CalcBox variant="supervisor" $isDarkMode={isDarkMode}>
              <CalcTitle variant="supervisor" $isDarkMode={isDarkMode}>Supervisor Assessment</CalcTitle>
              <CalcLine variant="supervisor" $isDarkMode={isDarkMode}>Items Scored: {scores.supervisor.completed}</CalcLine>
              <CalcLine variant="supervisor" $isDarkMode={isDarkMode}>Average: {scores.supervisor.rawAvg}</CalcLine>
              <CalcLine variant="supervisor" $isDarkMode={isDarkMode} strong>TOTAL: {scores.supervisor.total} / 10</CalcLine>
            </CalcBox> */}
            
            <CalcBox variant="admin" $isDarkMode={isDarkMode}>
              <CalcTitle variant="admin" $isDarkMode={isDarkMode}>Admin Final Assessment</CalcTitle>
              <CalcLine variant="admin" $isDarkMode={isDarkMode}>Items Scored: {scores.admin.completed}</CalcLine>
              <CalcLine variant="admin" $isDarkMode={isDarkMode}>Average: {scores.admin.rawAvg}</CalcLine>
              <CalcLine variant="admin" $isDarkMode={isDarkMode} strong>TOTAL: {scores.admin.total} / 10</CalcLine>
            </CalcBox>
          </CalcGrid>

          <ActionWrap>
            <SubmitButton onClick={handleSave} disabled={saving || savedRecently} success={savedRecently}>
              {saving ? "Processing..." : savedRecently ? "Saved Successfully! ✓" : "Save"}
            </SubmitButton>
          </ActionWrap>
        </SectionCard>
      </Main>
      <Footer />
    </Container>
  );
};

export default AdminAppraisalForm;